/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable object-shorthand */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-lonely-if */
/* eslint-disable no-unsafe-finally */
/* eslint-disable */
import { AppThunk } from '../../../store/reducers';
import { GET, POST, DELETE, PUT, PATCH } from '../../../service/HttpMethod';
import {
	InitialState,
	ActionConstant,
	ActionType,
	Lists,
	DocLists,
	SearchHistoryLists,
	DocumentHistoryLists,
	SearchHistoryDatas,
	autoAnalysisListDatas,
	UserLists,
	TradeList,
	TradeResult,
	MultiPackageTradeResult,
	TradeResultData,
	AllUserLists,
	ResultDoc,
	PageValList,
	PageValTextList,
	TradeResultCopy,
	MultiTradeResultCopy,
	ScopeDoc,
	KeywordCount,
	ProgressCount,
	KeywordId,
	CoordinationDoc,
	InteractiveResult,
	MultiInteractiveResult,
	ClearScanCurrentDrawings,
	ClearCurrentDrawingsData,
	ClearCurrentSpecificationsData,
	ClearSpecificationDetailsData,
	GetSpecificationDetails,
	GetSpecSummary,
	ConfirmSpecification,
	SpecLists,
	EnumProgressStatus,
	// TradeListMoveCopy
} from './types';
import {
	getAutoAnalysisCompletionSignature,
	waitForCompletedAutoAnalysisHistory,
} from './autoAnalysisCompletion';
import { toastFunction } from '../../../helpers/toastShow';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { normalizeKeywordResultsPayload } from '../../../utils/keywordResultDedupe';
import { pickProjectAreaResultMetadata } from '../../../utils/projectAreaResultMetadata';
import {
	buildPreviousCurrentItems,
	PreviousCurrentItems,
} from '../utils/makeCurrentRevisionWorkflow';

let scopeLocationRequestSequence = 0;
let scopeDocumentChecklistRollupRequestSequence = 0;
let bidPackageRequestSequence = 0;
const BID_PACKAGE_CACHE_TTL_MS = 30000;
const bidPackageRequestsInFlight = new Map<number, Promise<any>>();
const interactiveReviewChecklistRefreshesInFlight = new Map<number, Promise<any>>();
const autoAnalysisProgressRequestsInFlight = new Map<string, Promise<ProgressCount[]>>();
const searchHistoryByDivisionRequestsInFlight = new Map<string, Promise<any>>();

export interface AutoAnalysisCompletionReconciliationResult {
	committed: boolean;
	completionSignature: string;
}

interface AutoAnalysisCompletionRequest {
	autoAnalysisRows: any[];
	bidPackageId?: number;
	completionKey: string;
	completionSignature: string;
	progressRows: ProgressCount[];
	projectId: any;
}

interface AutoAnalysisCompletionWaiter {
	completionKey: string;
	completionSignature: string;
	promise: Promise<AutoAnalysisCompletionReconciliationResult>;
	reject: (error: any) => void;
	resolve: (result: AutoAnalysisCompletionReconciliationResult) => void;
}

interface AutoAnalysisCompletionWork extends AutoAnalysisCompletionRequest {
	waiters: Map<string, AutoAnalysisCompletionWaiter>;
}

interface AutoAnalysisCompletionQueue {
	active?: AutoAnalysisCompletionWork;
	pending?: AutoAnalysisCompletionWork;
}

const autoAnalysisCompletionRequestsInFlight = new Map<
	string,
	Promise<AutoAnalysisCompletionReconciliationResult>
>();
const autoAnalysisCompletionQueuesByScope = new Map<string, AutoAnalysisCompletionQueue>();
const historyCommittedAutoAnalysisCompletions = new Set<string>();
const handledAutoAnalysisCompletions = new Set<string>();

const getScopeLocationRequestKey = (projectId: any, bidPackageId?: number) => {
	const normalizedBidPackageId = Number(bidPackageId);
	const packageKey =
		Number.isInteger(normalizedBidPackageId) && normalizedBidPackageId > 0
			? String(normalizedBidPackageId)
			: 'all';
	return `${Number(projectId)}:${packageKey}`;
};

const getSearchHistoryByDivisionRequestKey = (
	projectId: any,
	groupBy?: string,
	bidPackageId?: number,
) => `${getScopeLocationRequestKey(projectId, bidPackageId)}:${groupBy || 'division'}`;
const getAutoAnalysisProgressRequestKey = (
	projectId: any,
	rowIds: number[],
	bidPackageId?: number,
) =>
	`${getScopeLocationRequestKey(projectId, bidPackageId)}:${Array.from(
		new Set(rowIds.map((rowId: number) => Number(rowId)).filter((rowId: number) => rowId > 0)),
	)
		.sort((left: number, right: number) => left - right)
		.join(',')}`;
const nextScopeLocationRequestId = (requestKey?: string) =>
	requestKey ? ++scopeLocationRequestSequence : undefined;

const filterProjectScopeHistory = (payload: any, projectId: number) => {
	if (!payload || !Array.isArray(payload.searchHistory)) return payload;
	return {
		...payload,
		searchHistory: payload.searchHistory
			.map((group: any) => ({
				...group,
				scopeDocuments: Array.isArray(group?.scopeDocuments)
					? group.scopeDocuments.filter(
							(document: any) =>
								document?.projectId === undefined ||
								document?.projectId === null ||
								Number(document.projectId) === projectId,
					  )
					: [],
			}))
			.filter((group: any) => group.scopeDocuments.length > 0),
	};
};

const filterProjectBidPackages = (rows: any, projectId: number) =>
	(Array.isArray(rows) ? rows : []).filter(
		(row: any) =>
			row?.projectId === undefined ||
			row?.projectId === null ||
			Number(row.projectId) === projectId,
	);

const initialState: InitialState = {
	initialList: true,
	keywordId: { rowId: '' },
	keywordCountData: { processCount: '', totalCount: '' },
	ProgressCountData: [
		{
			processCount: '',
			totalCount: '',
			progressId: 0,
			progressStatus: EnumProgressStatus.INPROGRESS,
		},
	],
	fetching: true,
	detailsFetching: true,
	tradeFetching: true,
	list: {
		id: 0,
		name: '',
		primaryContact: '',
		phone: '',
		email: '',
		startDate: '',
		location: '',
		structureType: '',
		skinTypes: [],
		showCheckDrawings: true,
		specStoreStatus: '',
	},
	statusCode: 0,
	noOfResults: 0,
	totalResults: 0,
	recentdocuments: [],
	recentSpecifications: [],
	searchhistory: [],
	searchhistoryByRequestKey: {},
	searchhistoryRequestIds: {},
	searchhistoryRequestKey: null,
	scopeDocumentChecklistProjectRollups: {
		projectId: 0,
		rollups: { byHistoryId: {}, byTradeId: {} },
	},
	searchhistorydata: [],
	documenthistory: [],
	tradelist: [],
	count: 0,
	documentcount: 0,
	specCount: 0,
	tradecount: 0,
	docList: [],
	traderesult: [],
	revisionScopeChecklistPatches: [],
	priortraderesult: [],
	diffresult: [],
	multitraderesult: [],
	interactiveresult: [],
	multiinteractiveresult: [],
	traderesultdata: [],
	traderesultFetching: true,
	traderesultcopy: [],
	priortraderesultcopy: [],
	diffresultcopy: [],
	multitraderesultcopy: [],
	traderesultFetchingcopy: true,
	traderesultcount: 0,
	users: [],
	usercount: 0,
	userFetching: true,
	allusers: [],
	allusercount: 0,
	alluserFetching: true,
	generatetraderesult: { s3PdfUrl: '', s3ExcelUrl: '' },
	generatetraderesultFetching: true,
	searchhistoryFetching: true,
	autoAnalysisListData: [],
	autoAnalysisListFetching: true,
	autoAnalysisListByRequestKey: {},
	autoAnalysisListRequestIds: {},
	autoAnalysisListRequestKey: null,
	documenthistoryFetching: true,
	pageValueFetching: true,
	pagevaluelist: { coordinates: [], name: '', pageNumbers: [], rotationAngle: [] },
	pagevaluetextlist: { Payload: '' },
	tradeResultStatus: false,
	// TradeListMoveCopy: []
	isActiveProject: true,
	scopeDocumentsArrayByTrade: { searchHistory: { title: '', scopeDocuments: [] } },
	coordinationDocuments: { count: 0, rows: [] },
	coordinationDocumentsFetching: true,
	alreadySearchedTradesList: [],
	alreadySearchedTradesListFetching: true,
	allPagesList: [],
	allPagesFetching: true,
	coordinationMarkupGenerating: true,
	coordinationMarkup: {
		coordinationMarkupUrl: '',
		status: '',
	},
	currentDrawingsFetching: true,
	currentDrawings: [],
	currentSpecificationsFetching: true,
	currentSpecifications: [],
	specificationDetailsFetching: true,
	specificationDetails: [],
	specSummary: [],
	scanCurrentDrawingsResult: [],
	scanCurrentDrawingsFetching: true,
	ClearScanCurrentDrawings: [],
	checkNewDrawingsResult: [],
	checkNewDrawingsResultFetching: true,
	isMakeCurrentActive: false,
	autoAnalysisTrades: [],
	autoAnalysisTradesFetching: true,
	canAutoAnalyze: true,
	remainingTimeMs: 0,
	bidPackagesFetching: true,
	bidPackages: [],
	bidPackagesByProjectId: {},
	bidPackagesProjectId: 0,
	bidPackagesRequestIds: {},
	bidPackagesUpdatedAtByProjectId: {},
	bidPackageColor: '',
	bidPackageAutoSOWList: [],
	bidPackageAutoSOWListFetching: true,
	exclusivityReviewData: { totalHits: 0, pages: [], hits: [] },
	exclusivityReviewFetching: false,
};
const getScopeDocumentHistoryKey = (history: any) =>
	String(
		(history &&
			(history.id || history.division || history.title || history.name || history.tradeId)) ||
			'',
	);

const getScopeDocumentRowKey = (doc: any) =>
	String((doc && (doc.id || doc.tradeId || doc.title || doc.tradeName)) || '');

const mergeScopeDocumentRefreshRollups = (currentDocs: any[] = [], nextDocs: any[] = []) => {
	const nextByKey = new Map<string, any>();
	nextDocs.forEach((doc: any) => {
		const key = getScopeDocumentRowKey(doc);
		if (key) nextByKey.set(key, doc);
	});

	const mergedKeys = new Set<string>();
	const mergedDocs = currentDocs.map((doc: any) => {
		const key = getScopeDocumentRowKey(doc);
		const nextDoc = key ? nextByKey.get(key) : null;
		if (!nextDoc) return doc;

		mergedKeys.add(key);
		return {
			...doc,
			...nextDoc,
		};
	});

	nextDocs.forEach((doc: any) => {
		const key = getScopeDocumentRowKey(doc);
		if (!key || !mergedKeys.has(key)) mergedDocs.push(doc);
	});

	return mergedDocs;
};

const mergeSearchHistoryRefreshRollups = (currentHistory: any[] = [], nextHistory: any[] = []) => {
	if (!currentHistory.length) return nextHistory;

	const nextByKey = new Map<string, any>();
	nextHistory.forEach((history: any) => {
		const key = getScopeDocumentHistoryKey(history);
		if (key) nextByKey.set(key, history);
	});

	const mergedKeys = new Set<string>();
	const mergedHistory = currentHistory.map((history: any) => {
		const key = getScopeDocumentHistoryKey(history);
		const nextItem = key ? nextByKey.get(key) : null;
		if (!nextItem) return history;

		mergedKeys.add(key);
		return {
			...history,
			scopeDocuments: mergeScopeDocumentRefreshRollups(
				history.scopeDocuments || [],
				nextItem.scopeDocuments || [],
			),
		};
	});

	nextHistory.forEach((history: any) => {
		const key = getScopeDocumentHistoryKey(history);
		if (!key || !mergedKeys.has(key)) mergedHistory.push(history);
	});

	return mergedHistory;
};

const mergeSearchHistoryDocumentRollups = (currentHistory: any[] = [], nextHistory: any[] = []) => {
	if (!currentHistory.length) return nextHistory;

	const nextDocsByKey = new Map<string, any>();
	nextHistory.forEach((history: any) => {
		(history.scopeDocuments || []).forEach((doc: any) => {
			const key = getScopeDocumentRowKey(doc);
			if (key) nextDocsByKey.set(key, doc);
		});
	});

	return currentHistory.map((history: any) => ({
		...history,
		scopeDocuments: (history.scopeDocuments || []).map((doc: any) => {
			const key = getScopeDocumentRowKey(doc);
			const nextDoc = key ? nextDocsByKey.get(key) : null;
			if (!nextDoc) return doc;

			return {
				...doc,
				scopeChecklistRefreshNeeded: nextDoc.scopeChecklistRefreshNeeded,
				scopeChecklistRefreshStatus: nextDoc.scopeChecklistRefreshStatus,
				scopeChecklistRefreshCounts: nextDoc.scopeChecklistRefreshCounts,
			};
		}),
	}));
};
export const SetProjectDetailsAction = (data: Lists): ActionType => ({
	type: ActionConstant.GET_LIST,
	data,
});

const GetKeywordCountAction = (data: KeywordCount): ActionType => ({
	type: ActionConstant.GET_KEYWORD_DATA,
	data,
});
const GetProgressCountAutoAnalysisAction = (data: ProgressCount[]): ActionType => ({
	type: ActionConstant.GET_PROGRESS_DATA,
	data,
});

const GetSearchProgressIdAction = (data: KeywordId): ActionType => ({
	type: ActionConstant.GET_KEYWORD_ID,
	data,
});
const ClearKeywordCountAction = (): ActionType => ({
	type: ActionConstant.CLEAR_KEYWORD_DATA,
});

export const GetClearScanCurrentDrawings = (): ActionType => ({
	type: ActionConstant.CLEAR_SCAN_CURRENT_DRAWINGS,
});

export const clearDataDetails = (): ActionType => ({
	type: ActionConstant.CLEAR_DATA_DETAILS,
});
export const clearUsers = (): ActionType => ({
	type: ActionConstant.CLEAR_USERS,
});
export const clearAllUsers = (): ActionType => ({
	type: ActionConstant.CLEAR_ALL_USERS,
});
export const clearSearchHistory = (
	requestKey?: string,
	requestId?: number,
	silent = false,
): ActionType => ({
	type: ActionConstant.CLEAR_SEARCHHISTORY,
	requestId,
	requestKey,
	silent,
});
export const clearAutoAnalysisListData = (requestKey?: string, requestId?: number): ActionType => ({
	type: ActionConstant.CLEAR_AUTOANALYSISLISTDATA,
	requestId,
	requestKey,
});

export const clearDocumentHistory = (): ActionType => ({
	type: ActionConstant.CLEAR_DOCUMENTHISTORY,
});
export const clearTrade = (): ActionType => ({
	type: ActionConstant.CLEAR_TRADE,
});
export const clearPageValueList = (): ActionType => ({
	type: ActionConstant.CLEAR_PAGE_VALUE_LIST,
});
export const clearPageValueTextList = (): ActionType => ({
	type: ActionConstant.CLEAR_PAGE_VALUE_TEXT_LIST,
});
export const clearTradeResult = (): ActionType => ({
	type: ActionConstant.CLEAR_TRADE_RESULT,
});
export const clearPriorResult = (): ActionType => ({
	type: ActionConstant.CLEAR_PRIOR_RESULT,
});
export const clearMultiPackageTradeResult = (): ActionType => ({
	type: ActionConstant.CLEAR_MULTI_PACKAGE_TRADE_RESULT,
});
export const clearTradeResultCopy = (): ActionType => ({
	type: ActionConstant.CLEAR_TRADE_RESULT_COPY,
});
export const clearMultiTradeResultCopy = (): ActionType => ({
	type: ActionConstant.CLEAR_MULTI_TRADE_RESULT_COPY,
});
export const clearMultiInteractiveTradeResult = (): ActionType => ({
	type: ActionConstant.CLEAR_MULTI_INTERACTIVE_TRADE_RESULT,
});

export const clearGenerateResultAction = (): ActionType => ({
	type: ActionConstant.CLEAR_GENERATE_RESULT_DOCUMENT,
});
export const clearStatus = (): ActionType => ({
	type: ActionConstant.CLEAR_STATUS,
});
export const setMakeCurrentActive = (): ActionType => ({
	type: ActionConstant.SET_MAKE_CURRENT_ACTIVE,
});
export const setMakeCurrentInactive = (): ActionType => ({
	type: ActionConstant.SET_MAKE_CURRENT_INACTIVE,
});
const GetRecentDocumentListAction = (data: DocLists): ActionType => ({
	type: ActionConstant.GET_RECENTDOCUMENTS,
	data,
});

const GetRecentSpecificationListAction = (data: SpecLists): ActionType => ({
	type: ActionConstant.GET_RECENTSPECIFICATION,
	data,
});

const GetSearchHistoryListAction = (
	data: SearchHistoryLists,
	options: { silent?: boolean; rollupsOnly?: boolean } = {},
	requestKey?: string,
	requestId?: number,
): ActionType => ({
	type: ActionConstant.GET_SEARCHHISTORY,
	data,
	requestId,
	requestKey,
	silent: options.silent,
	rollupsOnly: options.rollupsOnly,
});
export const SetScopeDocumentChecklistProjectRollupsAction = (
	projectId: number,
	rollups: any,
): ActionType => ({
	type: ActionConstant.SET_SCOPE_DOCUMENT_CHECKLIST_ROLLUPS,
	projectId,
	rollups,
});
const GetSearchHistoryDataAction = (data: SearchHistoryDatas): ActionType => ({
	type: ActionConstant.GET_SEARCHHISTORYDATA,
	data,
});
const GetAutoAnalysisListDataAction = (
	data: autoAnalysisListDatas,
	requestKey?: string,
	requestId?: number,
): ActionType => ({
	type: ActionConstant.GET_AUTOANALYSISLISTDATA,
	data,
	requestId,
	requestKey,
});
export const SetSearchHistoryFetchingCompleteAction = (
	requestKey?: string,
	requestId?: number,
): ActionType => ({
	type: ActionConstant.SET_SEARCHHISTORY_FETCHING_COMPLETE,
	requestId,
	requestKey,
});
export const SetAutoAnalysisListFetchingCompleteAction = (
	requestKey?: string,
	requestId?: number,
): ActionType => ({
	type: ActionConstant.SET_AUTOANALYSISLIST_FETCHING_COMPLETE,
	requestId,
	requestKey,
});

const GetDocumentHistoryListAction = (data: DocumentHistoryLists): ActionType => ({
	type: ActionConstant.GET_DOCUMENTHISTORY,
	data,
});

const GetUsersAction = (data: UserLists): ActionType => ({
	type: ActionConstant.GET_USERS,
	data,
});

const GetAllUsersAction = (data: AllUserLists): ActionType => ({
	type: ActionConstant.GET_ALL_USERS,
	data,
});

const GetGenerateResultAction = (data: ResultDoc): ActionType => ({
	type: ActionConstant.GET_GENERATE_RESULT_DOCUMENT,
	data,
});

const GetTradeListAction = (data: TradeList): ActionType => ({
	type: ActionConstant.GET_TRADE,
	data,
});
const GetPageValueAction = (data: PageValList): ActionType => ({
	type: ActionConstant.GET_PAGE_VALUE_LIST,
	data,
});
const GetPageValueTextAction = (data: PageValTextList): ActionType => ({
	type: ActionConstant.GET_PAGE_VALUE_TEXT_LIST,
	data,
});
export const GetTradeResultAction = (data: TradeResult): ActionType => ({
	type: ActionConstant.GET_TRADE_RESULT,
	data: normalizeKeywordResultsPayload(data),
});
export const GetTradeResultMutiPackageAction = (data: MultiPackageTradeResult): ActionType => ({
	type: ActionConstant.GET_TRADE_RESULT_MULTI_PACKAGE,
	data: normalizeKeywordResultsPayload(data),
});
export const GetInteractiveResultAction = (data: InteractiveResult): ActionType => ({
	type: ActionConstant.GET_INTERACTIVE_RESULT,
	data: normalizeKeywordResultsPayload(data),
});
export const GetMultiInteractiveResultAction = (data: MultiInteractiveResult): ActionType => ({
	type: ActionConstant.GET_MULTI_INTERACTIVE_RESULT,
	data: normalizeKeywordResultsPayload(data),
});
export const GetTradeResultActionData = (data: TradeResultData): ActionType => ({
	type: ActionConstant.GET_TRADE_RESULTDATA,
	data: normalizeKeywordResultsPayload(data),
});
export const GetTradeResultCopyAction = (data: TradeResultCopy): ActionType => ({
	type: ActionConstant.GET_TRADE_RESULT_COPY,
	data: normalizeKeywordResultsPayload(data),
});
export const GetMultiTradeResultCopyAction = (data: MultiTradeResultCopy): ActionType => ({
	type: ActionConstant.GET_MULTI_TRADE_RESULT_COPY,
	data: normalizeKeywordResultsPayload(data),
});

// const GetTradeListMoveCopyction = (data: TradeListMoveCopy): ActionType => ({
// 	type: ActionConstant.GET_TRADE_MOVE_COPY
// 	data,
// });
export const clearData = (): ActionType => ({
	type: ActionConstant.CLEAR_DATA,
});

export const GetScopeDocsByGroup = (data: ScopeDoc): ActionType => ({
	type: ActionConstant.GET_SCOPE_DOCS_BY_GROUP,
	data,
});

export const ClearScopeDocsByGroup = (): ActionType => ({
	type: ActionConstant.CLEAR_SCOPE_DOCS_BY_GROUP,
});

export const GetCoordinationDocs = (data: CoordinationDoc): ActionType => ({
	type: ActionConstant.GET_COORDINATION_DOCS,
	data,
});

export const ClearCoordinationDocs = (): ActionType => ({
	type: ActionConstant.CLEAR_COORDINATION_DOCS,
});

export const GetAlreadySearchedTrades = (data: any): ActionType => ({
	type: ActionConstant.GET_ALREADY_SEARCHED_TRADES,
	data,
});

export const ClearAlreadySearchedTrades = (): ActionType => ({
	type: ActionConstant.CLEAR_ALREADY_SEARCHED_TRADES,
});

export const GetAllPages = (data: any): ActionType => ({
	type: ActionConstant.GET_ALL_PAGES,
	data,
});

export const ClearAllPages = (): ActionType => ({
	type: ActionConstant.CLEAR_ALL_PAGES,
});

export const GenerateCoordinationMarkup = (data: any): ActionType => ({
	type: ActionConstant.GENERATE_COORDINATION_DOCS,
	data,
});

export const ClearGenerateCoordinationMarkup = (): ActionType => ({
	type: ActionConstant.CLEAR_GENERATE_COORDINATION_DOCS,
});

export const clearCurrentDrawingsData = (): ClearCurrentDrawingsData => ({
	type: ActionConstant.CLEAR_CURRENT_DRAWINGS_DATA,
});

export const clearCurrentSpecificationsData = (): ClearCurrentSpecificationsData => ({
	type: ActionConstant.CLEAR_CURRENT_SPECIFICATIONS_DATA,
});

export const clearSpecificationDetailsData = (): ClearSpecificationDetailsData => ({
	type: ActionConstant.CLEAR__SPECIFICATION_DETAILS_DATA,
});
const GetCurrentDrawingsListAction = (data: any): ActionType => ({
	type: ActionConstant.GET_CURRENT_DRAWINGS,
	data,
});

const GetCurrentSpecificationsListAction = (data: any): ActionType => ({
	type: ActionConstant.GET_CURRENT_SPECIFICATIONS,
	data,
});

const GetSpecificationFDetailsListAction = (data: any): ActionType => ({
	type: ActionConstant.GET_SPECIFICATION_DETAILS,
	data,
});
export const addSpecificationDetails = (data: any): ActionType =>
	GetSpecificationFDetailsListAction(data);

const ScanCurrentDrawingsListAction = (data: any): ActionType => ({
	type: ActionConstant.GET_SCAN_CURRENT_DRAWINGS,
	data,
});

const CheckForNewDrawingsListAction = (data: any): ActionType => ({
	type: ActionConstant.GET_CHECK_NEW_DRAWINGS,
	data,
});

export const ClearCheckForNewDrawingsListAction = (): ActionType => ({
	type: ActionConstant.CLEAR_CHECK_NEW_DRAWINGS,
});

export const getDiffResultAction = (data: any): ActionType => ({
	type: ActionConstant.GET_DIFF_RESULT,
	diffResults: data,
	diffResultsCopy: data,
});

export const CheckTradesForAutoAnalysisListAction = (data: any): ActionType => ({
	type: ActionConstant.GET_AUTO_ANALYSIS_TRADES_LIST,
	data,
});

export const ClearTradesForAutoAnalysisListAction = (): ActionType => ({
	type: ActionConstant.CLEAR_AUTO_ANALYSIS_TRADES_LIST,
});

const GetExclusivityReviewAction = (data: any): ActionType => ({
	type: ActionConstant.GET_EXCLUSIVITY_REVIEW,
	data,
});

export const ClearExclusivityReviewAction = (): ActionType => ({
	type: ActionConstant.CLEAR_EXCLUSIVITY_REVIEW,
});

const SetExclusivityReviewFetchingAction = (): ActionType => ({
	type: ActionConstant.SET_EXCLUSIVITY_REVIEW_FETCHING,
});

export const GetBidPackagesListAction = (
	data: any,
	projectId?: number,
	requestId?: number,
	receivedAt?: number,
): ActionType => ({
	type: ActionConstant.GET_BID_PACKAGES_LIST,
	data,
	projectId,
	receivedAt,
	requestId,
});

export const ClearBidPackagesListAction = (projectId?: number, requestId?: number): ActionType => ({
	type: ActionConstant.CLEAR_BID_PACKAGES_LIST,
	projectId,
	requestId,
});

export const SetBidPackagesFetchingCompleteAction = (
	projectId: number,
	requestId: number,
): ActionType => ({
	type: ActionConstant.SET_BID_PACKAGES_FETCHING_COMPLETE,
	projectId,
	requestId,
});

export const GetBidPackageAutoSOWListAction = (data: any): ActionType => ({
	type: ActionConstant.GET_BID_PACKAGE_AUTOSOW_LIST,
	data,
});

export const ClearBidPackageAutoSOWListAction = (): ActionType => ({
	type: ActionConstant.CLEAR_BID_PACKAGE_AUTOSOW_LIST,
});

export const getList = (data: any = {}): AppThunk => {
	const getConfig = { url: `project/${data}` };

	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			dispatch(SetProjectDetailsAction(data.data));
		} catch (error) {
			// dispatch(GetListAction([]));
			if (error && error.data && error.data.message) {
				if (error.data.message === 'ACCESS_DENIED') {
					dispatch(
						toastFunction(
							'Error',
							'Access denied. You are not authorized to view this project.',
							'',
						),
					);
					window.location.href = `/project`;
				} else dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};

export const clearKeywordCount = (projectId: any, tradeName: any, rowId: any): AppThunk => {
	const postConfig = {
		url: `/projects/deleteSearchProgress?projectId=${projectId}&tradeName=${tradeName}&rowId=${rowId?.rowId}`,
	};
	return async (dispatch) => {
		try {
			await POST(postConfig);

			dispatch(ClearKeywordCountAction());
		} catch (error) {
			// dispatch(GetListAction([]));
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};

export const deleteHistoryAndProgress = (
	projectId: any,
	tradeId: any,
	progressId: any,
	bidPackageId: any,
): AppThunk => {
	const postConfig = {
		url: `/projects/deleteHistoryAndProgress?projectId=${projectId}&tradeId=${tradeId}&progressId=${progressId}`,
	};
	return async (dispatch) => {
		try {
			await POST(postConfig);
			dispatch(toastFunction('Success', 'Successfully deleted the search', ''));
			dispatch(getSearchHistoryData(projectId, 'trade'));
			dispatch(getAutoAnalysisData(projectId, bidPackageId));
			// dispatch(ClearKeywordCountAction());
		} catch (error) {
			// dispatch(GetListAction([]));
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};

// Redux thunk
export const chatWithGPT = (apiRequestBody: any, projectId: number): AppThunk<Promise<any>> => {
	const postConfig = {
		url: `/chat`,
		data: { ...apiRequestBody, projectId },
	};

	return async (dispatch) => {
		try {
			// console.log(postConfig, 'postConfig');
			const response = await POST(postConfig); // your API call
			return response;
		} catch (error) {
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
			throw error;
		}
	};
};

export const getSearchProgressId = (projectId: any, tradeName: any): AppThunk => {
	const getConfig = {
		url: `/projects/searchProgressId?projectId=${projectId}&tradeName=${tradeName}`,
	};
	return async (dispatch) => {
		const { data = {} } = await GET(getConfig);
		dispatch(GetSearchProgressIdAction(data));
		localStorage.setItem('rowId', JSON.stringify(data));
	};
};
export const getKeywordCount = (projectId: any, tradeName: any, rowId: any): AppThunk => {
	const getConfig = {
		url: `/projects/searchProgress?projectId=${projectId}&tradeName=${tradeName}&rowId=${rowId.rowId}`,
	};
	return async (dispatch) => {
		try {
			dispatch(ClearKeywordCountAction());
			const { data = {} } = await GET(getConfig);
			dispatch(GetKeywordCountAction(data));
		} catch (error) {
			// dispatch(GetListAction([]));
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};

export const getProgressCountAutoAnalysis = (
	projectId: any,
	rowIds: number[],
	bidPackageId?: number,
): AppThunk<Promise<ProgressCount[]>> => {
	const postConfig = {
		url: `/projects/autoAnalysisProgress`,
		data: {
			projectId,
			rowIds,
		},
	};
	const requestKey = getAutoAnalysisProgressRequestKey(projectId, rowIds, bidPackageId);

	return async (dispatch) => {
		const previousRequest = autoAnalysisProgressRequestsInFlight.get(requestKey);
		if (previousRequest) return previousRequest;

		const request = (async (): Promise<ProgressCount[]> => {
			try {
				dispatch(ClearKeywordCountAction());
				const { data = [] } = await POST(postConfig);
				const progressRows = Array.isArray(data) ? data : [];
				dispatch(GetProgressCountAutoAnalysisAction(progressRows));
				return progressRows;
			} catch (error) {
				if (error?.data?.message) {
					dispatch(toastFunction('Error', error.data.message, ''));
				} else {
					dispatch(toastFunction('Error', 'Something went wrong', ''));
				}
				return [];
			}
		})();

		autoAnalysisProgressRequestsInFlight.set(requestKey, request);
		try {
			return await request;
		} finally {
			if (autoAnalysisProgressRequestsInFlight.get(requestKey) === request) {
				autoAnalysisProgressRequestsInFlight.delete(requestKey);
			}
		}
	};
};

const createAutoAnalysisCompletionWaiter = (
	completionKey: string,
	completionSignature: string,
): AutoAnalysisCompletionWaiter => {
	let resolve: (result: AutoAnalysisCompletionReconciliationResult) => void = () => undefined;
	let reject: (error: any) => void = () => undefined;
	const promise = new Promise<AutoAnalysisCompletionReconciliationResult>(
		(resolvePromise, rejectPromise) => {
			resolve = resolvePromise;
			reject = rejectPromise;
		},
	);
	return { completionKey, completionSignature, promise, reject, resolve };
};

const createAutoAnalysisCompletionWork = (
	request: AutoAnalysisCompletionRequest,
	waiter: AutoAnalysisCompletionWaiter,
): AutoAnalysisCompletionWork => ({
	...request,
	waiters: new Map([[waiter.completionKey, waiter]]),
});

const executeAutoAnalysisCompletionWork = async (
	dispatch: any,
	work: AutoAnalysisCompletionWork,
): Promise<AutoAnalysisCompletionReconciliationResult> => {
	if (handledAutoAnalysisCompletions.has(work.completionKey)) {
		return { committed: true, completionSignature: work.completionSignature };
	}
	if (!historyCommittedAutoAnalysisCompletions.has(work.completionKey)) {
		const committedHistory = await waitForCompletedAutoAnalysisHistory({
			progressRows: work.progressRows,
			autoAnalysisRows: work.autoAnalysisRows,
			loadHistory: () =>
				dispatch(
					getSearchHistoryByDivision(work.projectId, 'trade', work.bidPackageId, {
						silent: true,
					}),
				),
			maxAttempts: 1,
			retryDelayMs: 0,
		});
		if (!committedHistory) {
			return { committed: false, completionSignature: work.completionSignature };
		}
		historyCommittedAutoAnalysisCompletions.add(work.completionKey);
	}

	const refreshedAnalysis = await dispatch(getAutoAnalysisData(work.projectId, work.bidPackageId));
	return {
		committed: refreshedAnalysis !== undefined,
		completionSignature: work.completionSignature,
	};
};

function finishAutoAnalysisCompletionWork(
	dispatch: any,
	scopeKey: string,
	queue: AutoAnalysisCompletionQueue,
	work: AutoAnalysisCompletionWork,
) {
	work.waiters.forEach((waiter) => {
		if (autoAnalysisCompletionRequestsInFlight.get(waiter.completionKey) === waiter.promise) {
			autoAnalysisCompletionRequestsInFlight.delete(waiter.completionKey);
		}
	});
	if (queue.active === work) queue.active = undefined;

	const pending = queue.pending;
	if (pending) {
		queue.pending = undefined;
		startAutoAnalysisCompletionWork(dispatch, scopeKey, queue, pending);
	} else if (autoAnalysisCompletionQueuesByScope.get(scopeKey) === queue) {
		autoAnalysisCompletionQueuesByScope.delete(scopeKey);
	}
}

function startAutoAnalysisCompletionWork(
	dispatch: any,
	scopeKey: string,
	queue: AutoAnalysisCompletionQueue,
	work: AutoAnalysisCompletionWork,
) {
	queue.active = work;
	executeAutoAnalysisCompletionWork(dispatch, work).then(
		(result) => {
			const historyCommitted = historyCommittedAutoAnalysisCompletions.has(work.completionKey);
			work.waiters.forEach((waiter) => {
				if (historyCommitted) {
					historyCommittedAutoAnalysisCompletions.add(waiter.completionKey);
				}
				if (result.committed) {
					handledAutoAnalysisCompletions.add(waiter.completionKey);
					historyCommittedAutoAnalysisCompletions.delete(waiter.completionKey);
				}
				waiter.resolve({
					committed: result.committed,
					completionSignature: waiter.completionSignature,
				});
			});
			finishAutoAnalysisCompletionWork(dispatch, scopeKey, queue, work);
		},
		(error) => {
			work.waiters.forEach((waiter) => waiter.reject(error));
			finishAutoAnalysisCompletionWork(dispatch, scopeKey, queue, work);
		},
	);
}

export const reconcileCompletedAutoAnalysisHistory = (
	projectId: any,
	progressRows: ProgressCount[],
	autoAnalysisRows: any[],
	bidPackageId?: number,
): AppThunk<Promise<AutoAnalysisCompletionReconciliationResult>> => {
	const scopeKey = getScopeLocationRequestKey(projectId, bidPackageId);
	const completionSignature = getAutoAnalysisCompletionSignature(progressRows, autoAnalysisRows);
	const completionKey = `${scopeKey}:${completionSignature}`;

	return async (dispatch) => {
		if (!completionSignature) return { committed: true, completionSignature };
		if (handledAutoAnalysisCompletions.has(completionKey)) {
			return { committed: true, completionSignature };
		}

		const previousRequest = autoAnalysisCompletionRequestsInFlight.get(completionKey);
		if (previousRequest) return previousRequest;

		const waiter = createAutoAnalysisCompletionWaiter(completionKey, completionSignature);
		const request: AutoAnalysisCompletionRequest = {
			autoAnalysisRows,
			bidPackageId,
			completionKey,
			completionSignature,
			progressRows,
			projectId,
		};
		autoAnalysisCompletionRequestsInFlight.set(completionKey, waiter.promise);

		let queue = autoAnalysisCompletionQueuesByScope.get(scopeKey);
		if (!queue) {
			queue = {};
			autoAnalysisCompletionQueuesByScope.set(scopeKey, queue);
		}
		if (!queue.active) {
			startAutoAnalysisCompletionWork(
				dispatch,
				scopeKey,
				queue,
				createAutoAnalysisCompletionWork(request, waiter),
			);
		} else if (!queue.pending) {
			queue.pending = createAutoAnalysisCompletionWork(request, waiter);
		} else {
			Object.assign(queue.pending, request);
			queue.pending.waiters.set(waiter.completionKey, waiter);
		}

		return waiter.promise;
	};
};
export const getRecentDocuments = (datas: any = {}): AppThunk => {
	// console.log("getRecentDocuments function has started...");
	const getConfig = { url: `document?sortKey=name&sortOrder=asc&projectId=${datas}` };
	// console.log("So the data is fetched as above...");
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			// console.log("About to do GetRecentDocumentListAction...");
			dispatch(GetRecentDocumentListAction(data.data));
			// console.log("SO the data recentdocuments is updated");
		} catch (error) {
			// dispatch(GetRecentDocumentListAction([]));
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};

export const getRecentSpecifications = (datas: any = {}): AppThunk => {
	const getConfig = { url: `specifications?sortKey=name&sortOrder=asc&projectId=${datas}` };
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			dispatch(GetRecentSpecificationListAction(data.data));
		} catch (error) {
			// dispatch(GetRecentDocumentListAction([]));
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};

export const getSearchHistory = (datas: any = {}): AppThunk => {
	const getConfig = { url: `history?&projectId=${datas}` };
	return async (dispatch) => {
		try {
			//dispatch(clearSearchHistory());
			const { data = {} } = await GET(getConfig);
			dispatch(GetSearchHistoryListAction(data));
		} catch (error) {
			// dispatch(GetRecentDocumentListAction([]));
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};
export const getSearchHistoryData = (projectId: any, groupBy: any): AppThunk => {
	const getConfig = { url: `historyByDivision?&projectId=${projectId}&groupBy=${groupBy}` };
	return async (dispatch) => {
		try {
			// dispatch(clearSearchHistory());
			const { data = {} } = await GET(getConfig);
			dispatch(GetSearchHistoryDataAction(data));
		} catch (error) {
			// dispatch(GetRecentDocumentListAction([]));
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};

export const getAutoAnalysisData = (
	projectId: any,
	bidPackageId?: number,
): AppThunk<Promise<any>> => {
	const getConfig = { url: `autoAnalysisList?&projectId=${projectId}` };
	const requestKey = getScopeLocationRequestKey(projectId, bidPackageId);
	const requestId = nextScopeLocationRequestId(requestKey);
	if (bidPackageId) {
		getConfig.url = getConfig.url.concat(`&bidPackageId=${bidPackageId}`);
	}
	return async (dispatch) => {
		dispatch(clearAutoAnalysisListData(requestKey, requestId));
		try {
			const { data = {} } = await GET(getConfig);

			dispatch(GetAutoAnalysisListDataAction(data, requestKey, requestId));
			return data;
		} catch (error) {
			dispatch(SetAutoAnalysisListFetchingCompleteAction(requestKey, requestId));
			// dispatch(GetRecentDocumentListAction([]));
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
			return undefined;
		}
	};
};

export const getDocumentHistory = (projectId: any, tradeId: any, userId: any): AppThunk => {
	const getConfig = {
		url: `documentHistory?projectId=${projectId}&tradeId=${tradeId}&userId=${userId}`,
	};
	return async (dispatch) => {
		try {
			dispatch(clearDocumentHistory());
			const { data = {} } = await GET(getConfig);
			dispatch(GetDocumentHistoryListAction(data));
		} catch (error) {
			// dispatch(GetRecentDocumentListAction([]));
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};

export const getUsers = (projectId: number): AppThunk => {
	const getConfig = { url: `project/${projectId}/users` };
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			dispatch(GetUsersAction(data));
		} catch (error) {
			// dispatch(GetRecentDocumentListAction([]));
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};

export const getAllUsers = (projectId: number, searchKey: string): AppThunk => {
	const getConfig = { url: `users?projectId=${projectId}&searchKey=${searchKey}` };
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			dispatch(GetAllUsersAction(data));
		} catch (error) {
			// dispatch(GetRecentDocumentListAction([]));
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};
export const getSearchHistoryByDivision = (
	projectId: any,
	groupBy?: string,
	bidPackageId?: number,
	options: { silent?: boolean; rollupsOnly?: boolean } = {},
): AppThunk<Promise<any>> => {
	const getConfig = { url: `historyByDivision?&projectId=${projectId}&groupBy=${groupBy}` };
	const requestKey = getScopeLocationRequestKey(projectId, bidPackageId);
	const inFlightKey = getSearchHistoryByDivisionRequestKey(projectId, groupBy, bidPackageId);
	const requestId = nextScopeLocationRequestId(requestKey);

	if (bidPackageId) {
		getConfig.url = getConfig.url.concat(`&bidPackageId=${bidPackageId}`);
	}
	return async (dispatch, getState) => {
		let networkRequest: Promise<any> | undefined;
		try {
			if (requestKey) {
				dispatch(clearSearchHistory(requestKey, requestId, Boolean(options.silent)));
			} else if (!options.silent) {
				dispatch(clearSearchHistory());
			}
			networkRequest = searchHistoryByDivisionRequestsInFlight.get(inFlightKey);
			if (!networkRequest) {
				const createdRequest = GET(getConfig) as Promise<any>;
				networkRequest = createdRequest;
				searchHistoryByDivisionRequestsInFlight.set(inFlightKey, createdRequest);
			}
			const { data = {} } = await networkRequest;
			const scopedData = filterProjectScopeHistory(data, Number(projectId));
			const projectState =
				typeof getState === 'function' ? getState().projectDetailsStore : undefined;
			const decoratedData = decorateSearchHistoryWithScopeDocumentChecklistRollups(
				scopedData,
				Number(projectId),
				projectState && projectState.scopeDocumentChecklistProjectRollups,
			);
			dispatch(GetSearchHistoryListAction(decoratedData, options, requestKey, requestId));
			return data;
		} catch (error) {
			dispatch(SetSearchHistoryFetchingCompleteAction(requestKey, requestId));
			if (!options.silent) {
				if (error && error.data && error.data.message) {
					dispatch(toastFunction('Error', error.data.message, ''));
				} else {
					dispatch(toastFunction('Error', 'Something went wrong', ''));
				}
			}
			return undefined;
		} finally {
			if (searchHistoryByDivisionRequestsInFlight.get(inFlightKey) === networkRequest) {
				searchHistoryByDivisionRequestsInFlight.delete(inFlightKey);
			}
		}
	};
};

const EMPTY_SCOPE_DOCUMENT_CHECKLIST_ROLLUP = {
	needed: false,
	status: 'IDLE',
	counts: { needed: 0, active: 0, failed: 0 },
};

const getScopeDocumentChecklistRollupForDoc = (rollups: any = {}, doc: any = {}) =>
	(rollups.byHistoryId && rollups.byHistoryId[String(doc.id)]) ||
	(rollups.byTradeId && rollups.byTradeId[String(doc.tradeId)]) ||
	EMPTY_SCOPE_DOCUMENT_CHECKLIST_ROLLUP;

const buildScopeDocumentChecklistRollupSearchHistory = (
	currentHistory: any[] = [],
	rollups: any = {},
) =>
	(currentHistory || []).map((history: any) => ({
		...history,
		scopeDocuments: (history.scopeDocuments || []).map((doc: any) => {
			const rollup = getScopeDocumentChecklistRollupForDoc(rollups, doc);
			return {
				...doc,
				scopeChecklistRefreshNeeded: rollup.needed,
				scopeChecklistRefreshStatus: rollup.status,
				scopeChecklistRefreshCounts: rollup.counts,
			};
		}),
	}));

export const decorateSearchHistoryWithScopeDocumentChecklistRollups = (
	payload: any,
	projectId: number,
	projectRollupState: any,
) => {
	if (!payload || !Array.isArray(payload.searchHistory)) return payload;
	if (!projectRollupState || Number(projectRollupState.projectId) !== Number(projectId)) {
		return payload;
	}

	return {
		...payload,
		searchHistory: buildScopeDocumentChecklistRollupSearchHistory(
			payload.searchHistory,
			projectRollupState.rollups || {},
		),
	};
};

export const refreshScopeDocumentChecklistRollups = (
	projectId: any,
): AppThunk<Promise<any>> => async (dispatch, getState) => {
	const normalizedProjectId = Number(projectId);
	const requestId = ++scopeDocumentChecklistRollupRequestSequence;
	try {
		const { data = {} } = await GET({
			url: `projects/${projectId}/scopeDocumentChecklist/groups/rollups`,
		});
		const scopeDocumentChecklist = data.scopeDocumentChecklist || data;
		const rollups = scopeDocumentChecklist.rollups || {};
		const latestHistory = getState().projectDetailsStore.searchhistory || [];
		if (requestId !== scopeDocumentChecklistRollupRequestSequence) {
			return { rollups, searchHistory: latestHistory, stale: true };
		}
		const searchHistory = buildScopeDocumentChecklistRollupSearchHistory(latestHistory, rollups);
		dispatch(SetScopeDocumentChecklistProjectRollupsAction(normalizedProjectId, rollups));
		dispatch(GetSearchHistoryListAction({ searchHistory } as any, { rollupsOnly: true }));
		return { projectId: normalizedProjectId, rollups, searchHistory };
	} catch (error) {
		if (requestId === scopeDocumentChecklistRollupRequestSequence) {
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Failed to refresh scope checklist indicators', ''));
			}
		}
		const currentState = getState().projectDetailsStore;
		const currentRollupState = currentState.scopeDocumentChecklistProjectRollups;
		return {
			projectId: normalizedProjectId,
			failed: true,
			rollups:
				Number(currentRollupState && currentRollupState.projectId) === normalizedProjectId
					? currentRollupState.rollups
					: {},
			searchHistory: currentState.searchhistory || [],
		};
	}
};

export function create(datas: any = {}, projectId: number): AppThunk {
	const putConfig = {
		data: datas,
		url: `project/${projectId}`,
	};
	return async (dispatch) => {
		try {
			const { status = 0 } = await PUT(putConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			dispatch(getSearchHistoryByDivision(projectId, 'division'));
			dispatch(clearDataDetails());
			dispatch(getList(projectId));
			dispatch(clearData());
			dispatch(getRecentDocuments(projectId));
			dispatch(toastFunction('Success', 'Project updated successfully', ''));
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'Project updation failed', ''));
		}
	};
}
function callApi(projectId: number, tradeName: string, tradeId: any): AppThunk {
	return async (dispatch) => {
		setTimeout(() => dispatch(getGenerateResult(projectId, tradeName, tradeId)), 30000);
	};
}
let counter = 0;
export function getGenerateResult(projectId: number, tradeName: string, tradeId: any): AppThunk {
	const getConfig = {
		url: `generateDocuments?projectId=${projectId}&tradeName=${tradeName}&tradeId=${tradeId}`,
	};
	return async (dispatch) => {
		try {
			dispatch(clearGenerateResultAction());
			counter += 1;
			const { status = 0, data = {} } = await GET(getConfig);
			if (counter < 28 && (data.s3ExcelUrl === null || data.s3PdfUrl === null)) {
				dispatch(callApi(projectId, tradeName, tradeId));
			} else {
				if (counter < 28) {
					dispatch(GetGenerateResultAction(data));
					dispatch({ type: ActionConstant.GET_STATUS, status });
				} else {
					dispatch(toastFunction('Error', 'Scope Document generation failed', ''));
					setTimeout(() => (window.location.href = `/project/${projectId}`), 3000);
				}
			}
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
		}
	};
}

export function generateResult(
	datas: any = {},
	projectId: number,
	tradeName: string,
	save: string,
	tradeId?: any,
	searchHistoryId?: any,
	drawingRevisionAnalysisSessionId?: number | string | null,
): AppThunk {
	const postConfig = {
		data: {
			searchResults: normalizeKeywordResultsPayload(JSON.parse(JSON.stringify(datas))),
			tradeName,
			projectId,
			type: save,
			tradeId,
			searchHistoryId,
			...(drawingRevisionAnalysisSessionId !== undefined &&
			drawingRevisionAnalysisSessionId !== null
				? { drawingRevisionAnalysisSessionId }
				: {}),
		},
		url: `generateDocuments`,
	};
	return async (dispatch) => {
		try {
			dispatch(clearGenerateResultAction());
			const { data = {} } = await POST(postConfig);
			if (data.status === true) {
				dispatch(getGenerateResult(projectId, tradeName, tradeId));
			} else if (data.status === false && data.progressStatus === false) {
				// eslint-disable-next-line no-alert
				alert(
					'Search Results has more than 5000 details prior to Move/Copy/Delete operations. Document Generation may affect due to large count. Please wait',
				);
				dispatch(getGenerateResult(projectId, tradeName, tradeId));
			}
			if (data.progressStatus === true) {
				dispatch(getSearchHistoryByDivision(projectId, 'trade'));
				dispatch(refreshScopeDocumentChecklistRollups(projectId));
				dispatch(getBidPackages(projectId, { force: true }));
				dispatch(toastFunction('Success', `${data.message} `, ''));
			} else if (data.progressStatus === null) {
				dispatch(toastFunction('Error', `Failed to save the progress`, ''));
			}
		} catch (error) {
			dispatch(toastFunction('Error', error?.data?.message, ''));
			setTimeout(function () {
				window.location.href = `/project/${projectId}`;
			}, 3000);
		}
	};
}

export function updateHighlightMetadata(projectId: number, uid: any, metadata: any): AppThunk {
	const patchConfig = {
		data: { uid, ...metadata },
		url: `projects/${projectId}/highlightMetadata`,
	};
	return async (dispatch) => {
		try {
			await PATCH(patchConfig);
		} catch (error) {
			dispatch(
				toastFunction('Error', error?.data?.message || 'Failed to save highlight metadata', ''),
			);
		}
	};
}

export function analysisResult(
	currentData: any = {},
	priorData: any = {},
	diffData: any = {},
	projectId: number,
	tradeName: string,
	save: string,
	tradeId?: any,
	replaceCurrentScope = false,
	searchHistoryId?: any,
	acceptMergedChecklistAsCurrent = false,
	drawingRevisionAnalysisSessionId?: number | string | null,
): AppThunk<Promise<boolean>> {
	const postConfig = {
		data: {
			analysisResults: normalizeKeywordResultsPayload(JSON.parse(JSON.stringify(currentData))),
			priorData: normalizeKeywordResultsPayload(JSON.parse(JSON.stringify(priorData))),
			diffData: normalizeKeywordResultsPayload(JSON.parse(JSON.stringify(diffData))),
			tradeName,
			projectId,
			type: save,
			tradeId,
			replaceCurrentScope,
			searchHistoryId,
			...(acceptMergedChecklistAsCurrent ? { acceptMergedChecklistAsCurrent: true } : {}),
			...(drawingRevisionAnalysisSessionId !== undefined &&
			drawingRevisionAnalysisSessionId !== null
				? { drawingRevisionAnalysisSessionId }
				: {}),
		},
		url: `saveChangeAnalysisResult`,
	};
	return async (dispatch) => {
		try {
			const { data = {} } = await POST(postConfig);
			if (data.status === true) {
				dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			} else if (data.status === false && data.progressStatus === false) {
				// eslint-disable-next-line no-alert
			}
			if (data.progressStatus === true) {
				dispatch(refreshScopeDocumentChecklistRollups(projectId));
				dispatch(toastFunction('Success', `${data.message} `, ''));
				return true;
			} else if (data.progressStatus === null) {
				dispatch(toastFunction('Error', `Failed to save the progress`, ''));
				return false;
			}
			return data.status === true;
		} catch (error) {
			dispatch(toastFunction('Error', error.data.message, ''));
			if (!replaceCurrentScope) {
				setTimeout(function () {
					window.location.href = `/project/${projectId}`;
				}, 3000);
			}
			return false;
		}
	};
}

export function copyMove(
	fromTradeName: string,
	toTradeName: string,
	searchResult: [],
	projectId: number,
	moveorcopy: string,
	fromTradeId: any,
	toTradeId: any,
): AppThunk {
	const postConfig = {
		data: { searchResult, projectId },
		url: `copy?fromTrade=${fromTradeName}&toTrade=${toTradeName}&type=${moveorcopy}&fromTradeId=${fromTradeId}&toTradeId=${toTradeId}`,
	};
	return async (dispatch) => {
		try {
			await POST(postConfig);
			if (moveorcopy === 'copy') {
				dispatch(toastFunction('Success', `Items copied to ${toTradeName} successfully `, ''));
			}
			if (moveorcopy === 'move') {
				dispatch(toastFunction('Success', `Items moved to ${toTradeName} successfully `, ''));
				dispatch(refreshScopeDocumentChecklistRollups(projectId));
			}
		} catch (error) {
			if (moveorcopy === 'copy') {
				dispatch(toastFunction('Error', `Failed to copy items `, ''));
			}
			if (moveorcopy === 'move') {
				dispatch(toastFunction('Error', `Failed to move items `, ''));
			}
		}
	};
}

export function addUsers(data: any = [], projectId: number): AppThunk {
	const postConfig = {
		data: { userIdArray: data },
		url: `project/${projectId}/users`,
	};
	return async (dispatch) => {
		try {
			const { status = 0 } = await POST(postConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			dispatch(clearUsers());
			dispatch(clearAllUsers());
			dispatch(getUsers(projectId));
			dispatch(getAllUsers(projectId, ''));
			dispatch(toastFunction('Success', 'User assignment successful', ''));
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'User assignment failed', ''));
		}
	};
}

export function multiPackageTradeSearch(
	projectId: number,
	searchHistoryIds?: any,
	bidPackageId?: number,
): AppThunk {
	const postConfig = {
		data: { bidPackageId, tradeId: searchHistoryIds },
		url: `projects/${projectId}/searchTradeInteractiveReview`,

		// cancelToken: cancelToken,
	};

	return async (dispatch) => {
		try {
			console.log('inside');
			dispatch(clearMultiPackageTradeResult());
			dispatch(clearMultiTradeResultCopy());
			dispatch(clearMultiInteractiveTradeResult());
			const { data = {} } = await POST(postConfig);

			await dispatch(GetTradeResultMutiPackageAction(data));
			// eslint-disable-next-line no-console
			// if (data.status === true) {
			// 	// eslint-disable-next-line no-alert
			// 	alert(
			// 		'Scope documents unable to be generated due to deleted documents.  Please delete the previous trade searches and analyze again',
			// 	);
			// }

			let arr: any = [];
			let arrTwo: any = [];
			data.multiPackageSearchResults.forEach((trade: any) => {
				trade.signedUrlGenerations.forEach((fr: any) => {
					fr.groups.forEach((g: any) => {
						g.finalResult.forEach((fr: any) => {
							fr.files.forEach((pn: any) => {
								arr.push({
									keyword: fr.keyword,
									...pickProjectAreaResultMetadata(pn),
									coordinates: pn.coordinates,
									wordCoordinates: pn.wordCoordinates,
									wordCoordinateMatch: pn.wordCoordinateMatch,
									rotationAngle: pn.rotationAngle,
									signedUrl: pn.signedUrl,
									pdfImageSignedUrl: pn.pdfImageSignedUrl,
									pageNumber: pn.pageNumber,
									uid: pn.uid,
									isDeleted: pn.isDeleted,
									documentType: pn.documentType,
									fileName: pn.fileName,
									version: pn.version,
									versionNumber: pn.versionNumber,
									pdfImageKey: pn.pdfImageKey,
									pdfKey: pn.pdfKey,
									comment: pn.comment || '',
									adjustedCoordinates: pn.adjustedCoordinates,
									adjustedCoordinateSpace: pn.adjustedCoordinateSpace,
									adjustedPageWidth: pn.adjustedPageWidth,
									adjustedPageHeight: pn.adjustedPageHeight,
									adjustedRotationAngle: pn.adjustedRotationAngle,
								});
							});
						});
					});
				});
				arrTwo.push({
					tradeName: trade.tradeName,
					signedUrlgenerations: arr,
					package: trade.package,
				});
				arr = [];
			});

			let arrCopy: any = [];
			const clone = normalizeKeywordResultsPayload(JSON.parse(JSON.stringify(data)));

			clone.multiPackageSearchResults.forEach((trade: any) => {
				for (let i = 0; i < trade.signedUrlGenerations.length; i += 1) {
					for (let g = 0; g < trade.signedUrlGenerations[i].groups.length; g += 1) {
						for (
							let j = 0;
							j < trade.signedUrlGenerations[i].groups[g].finalResult.length;
							j += 1
						) {
							const result: any = [];
							let counter = 0;
							trade.signedUrlGenerations[i].groups[g].finalResult[j].files.forEach(
								(function (hash) {
									return function (a: any) {
										if (!hash[a.text]) {
											hash[a.text] = {
												text: a.text,
												pdfImageSignedUrl: a.pdfImageSignedUrl,
												...pickProjectAreaResultMetadata(a),
												details: [],
												sid: counter,
											};
											counter += 1;
											result.push(hash[a.text]);
										}
										const x: any = {
											...pickProjectAreaResultMetadata(a),
											coordinates: a.coordinates,
											documentType: a.documentType,
											fileName: a.fileName,
											pageNumber: a.pageNumber,
											pdfImageSignedUrl: a.pdfImageSignedUrl,
											rotationAngle: a.rotationAngle,
											signedUrl: a.signedUrl,
											text: a.text,
											uid: a.uid,
											isDeleted: a.isDeleted,
											isMove: a.isMove,
											isCopy: a.isCopy,
											movedFrom: a.movedFrom,
											wordCoordinates: a.wordCoordinates,
											wordCoordinateMatch: a.wordCoordinateMatch,
											version: a.version,
											versionNumber: a.versionNumber,
											pdfImageKey: a.pdfImageKey,
											pdfKey: a.pdfKey,
											comment: a.comment || '',
											adjustedCoordinates: a.adjustedCoordinates,
											adjustedCoordinateSpace: a.adjustedCoordinateSpace,
											adjustedPageWidth: a.adjustedPageWidth,
											adjustedPageHeight: a.adjustedPageHeight,
											adjustedRotationAngle: a.adjustedRotationAngle,
										};
										hash[a.text].details.push(x);
									};
								})(Object.create(null)),
							);

							trade.signedUrlGenerations[i].groups[g].finalResult[j].files = result;

							for (
								let a = 0;
								a < trade.signedUrlGenerations[i].groups[g].finalResult[j].files.length;
								a += 1
							) {
								for (
									let b = 0;
									b <
									trade.signedUrlGenerations[i].groups[g].finalResult[j].files[a].details.length;
									b += 1
								) {
									if (
										trade.signedUrlGenerations[i].groups[g].finalResult[j].files[a].details[b]
											.isDeleted === true
									) {
										trade.signedUrlGenerations[i].groups[g].finalResult[j].files[
											a
										].isDeleted = true;
										break;
									}
								}
							}
						}
					}
				}
				arrCopy.push({
					tradeName: trade.tradeName,
					signedUrlgenerations: trade.signedUrlGenerations,
				});
			});

			// //  arr.sort((a: any, b: any) => a.documentType.localeCompare(b.documentType));
			arrTwo.forEach((obj: any) => {
				obj.signedUrlgenerations.sort((a: any, b: any) => {
					// Extract timestamp and page numbers from file names
					const timestampA = parseInt(a.fileName.split('_')[1]);
					const pageA = parseInt(a.fileName.split('_')[2].split('.')[0]);
					const timestampB = parseInt(b.fileName.split('_')[1]);
					const pageB = parseInt(b.fileName.split('_')[2].split('.')[0]);
					// Compare timestamps
					if (timestampA !== timestampB) {
						return timestampA - timestampB;
					} // If timestamps are equal, compare page numbers
					return pageA - pageB;
				});
			});

			dispatch(GetMultiTradeResultCopyAction(clone));
			dispatch(GetMultiInteractiveResultAction(arrTwo));
		} catch (error) {
			// console.log(error);
			if (error.data) {
				dispatch(toastFunction('Error', error.data.message ? error.data.message : error.data, ''));
				if (error.data.message === 'Exceeded subscription limit') {
					setTimeout(function () {
						window.location.href = `/profile`;
					}, 3000);
				} else {
					setTimeout(function () {
						// window.location.href = `/project/${projectId}`;
					}, 3000);
				}
			} else {
				dispatch(toastFunction('Success', 'Search cancelled', ''));
			}

			// console.log(error);

			// dispatch(toastFunction('Error', error.data.message ? error.data.message : error.data, ''));
			// if (error.data.message === 'Exceeded subscription limit') {
			// 	setTimeout(function () {
			// 		window.location.href = `/profile`;
			// 	}, 3000);
			// } else {
			// 	setTimeout(function () {
			// 		window.location.href = `/project/${projectId}`;
			// 	}, 3000);
			// }
		}
	};
}

export function tradeSearch(
	projectId: number,
	tradeName: string,
	tradeId?: any,
	rowId?: any,
	cancelToken?: any,
	searchHistoryId?: any,
): AppThunk {
	const searchHistoryQuery = searchHistoryId
		? `&searchHistoryId=${encodeURIComponent(String(searchHistoryId))}`
		: '';
	const getConfig = {
		url: `projects/${projectId}/search?tradeName=${tradeName}&tradeId=${tradeId}&rowId=${
			rowId?.rowId || ''
		}${searchHistoryQuery}`,
		cancelToken: cancelToken,
	};
	return async (dispatch) => {
		try {
			dispatch(clearTradeResult());
			dispatch(clearTradeResultCopy());
			const { data = {} } = await GET(getConfig);
			console.log(data, 'DDDD2222');
			dispatch(GetTradeResultAction(data));
			// eslint-disable-next-line no-console
			// if (data.status === true) {
			// 	// eslint-disable-next-line no-alert
			// 	alert(
			// 		'Scope documents unable to be generated due to deleted documents.  Please delete the previous trade searches and analyze again',
			// 	);
			// }

			let arr: any = [];
			data.searchResults.forEach((fr: any) => {
				fr.groups.forEach((g: any) => {
					g.finalResult.forEach((fr: any) => {
						fr.files.forEach((pn: any) => {
							arr.push({
								keyword: fr.keyword,
								...pickProjectAreaResultMetadata(pn),
								coordinates: pn.coordinates,
								wordCoordinates: pn.wordCoordinates,
								wordCoordinateMatch: pn.wordCoordinateMatch,
								rotationAngle: pn.rotationAngle,
								signedUrl: pn.signedUrl,
								pdfImageSignedUrl: pn.pdfImageSignedUrl,
								pageNumber: pn.pageNumber,
								uid: pn.uid,
								isDeleted: pn.isDeleted,
								documentType: pn.documentType,
								fileName: pn.fileName,
								version: pn.version,
								versionNumber: pn.versionNumber,
								comment: pn.comment || '',
								adjustedCoordinates: pn.adjustedCoordinates,
								adjustedCoordinateSpace: pn.adjustedCoordinateSpace,
								adjustedPageWidth: pn.adjustedPageWidth,
								adjustedPageHeight: pn.adjustedPageHeight,
								adjustedRotationAngle: pn.adjustedRotationAngle,
							});
						});
					});
				});
			});

			const clone = normalizeKeywordResultsPayload(JSON.parse(JSON.stringify(data)));

			for (let i = 0; i < clone.searchResults.length; i += 1) {
				for (let g = 0; g < clone.searchResults[i].groups.length; g += 1) {
					for (let j = 0; j < clone.searchResults[i].groups[g].finalResult.length; j += 1) {
						const result: any = [];
						let counter = 0;
						clone.searchResults[i].groups[g].finalResult[j].files.forEach(
							(function (hash) {
								return function (a: any) {
									if (!hash[a.text]) {
										hash[a.text] = {
											text: a.text,
											pdfImageSignedUrl: a.pdfImageSignedUrl,
											...pickProjectAreaResultMetadata(a),
											details: [],
											sid: counter,
										};
										counter += 1;
										result.push(hash[a.text]);
									}
									const x: any = {
										...pickProjectAreaResultMetadata(a),
										coordinates: a.coordinates,
										documentType: a.documentType,
										fileName: a.fileName,
										pageNumber: a.pageNumber,
										pdfImageSignedUrl: a.pdfImageSignedUrl,
										rotationAngle: a.rotationAngle,
										signedUrl: a.signedUrl,
										text: a.text,
										uid: a.uid,
										isDeleted: a.isDeleted,
										isMove: a.isMove,
										isCopy: a.isCopy,
										movedFrom: a.movedFrom,
										wordCoordinates: a.wordCoordinates,
										wordCoordinateMatch: a.wordCoordinateMatch,
										version: a.version,
										versionNumber: a.versionNumber,
										pdfImageKey: a.pdfImageKey,
										pdfKey: a.pdfKey,
										comment: a.comment || '',
										adjustedCoordinates: a.adjustedCoordinates,
										adjustedCoordinateSpace: a.adjustedCoordinateSpace,
										adjustedPageWidth: a.adjustedPageWidth,
										adjustedPageHeight: a.adjustedPageHeight,
										adjustedRotationAngle: a.adjustedRotationAngle,
									};
									hash[a.text].details.push(x);
								};
							})(Object.create(null)),
						);

						clone.searchResults[i].groups[g].finalResult[j].files = result;

						for (
							let a = 0;
							a < clone.searchResults[i].groups[g].finalResult[j].files.length;
							a += 1
						) {
							for (
								let b = 0;
								b < clone.searchResults[i].groups[g].finalResult[j].files[a].details.length;
								b += 1
							) {
								if (
									clone.searchResults[i].groups[g].finalResult[j].files[a].details[b].isDeleted ===
									true
								) {
									clone.searchResults[i].groups[g].finalResult[j].files[a].isDeleted = true;
									break;
								}
							}
						}
					}
				}
			}

			if (clone.priorSearchResults)
				for (let i = 0; i < clone.priorSearchResults.length; i += 1) {
					for (let g = 0; g < clone.priorSearchResults[i].groups.length; g += 1) {
						for (let j = 0; j < clone.priorSearchResults[i].groups[g].finalResult.length; j += 1) {
							const result: any = [];
							let counter = 0;
							clone.priorSearchResults[i].groups[g].finalResult[j].files.forEach(
								(function (hash) {
									return function (a: any) {
										if (!hash[a.text]) {
											hash[a.text] = {
												text: a.text,
												pdfImageSignedUrl: a.pdfImageSignedUrl,
												...pickProjectAreaResultMetadata(a),
												details: [],
												sid: counter,
											};
											counter += 1;
											result.push(hash[a.text]);
										}
										const x: any = {
											...pickProjectAreaResultMetadata(a),
											coordinates: a.coordinates,
											documentType: a.documentType,
											fileName: a.fileName,
											pageNumber: a.pageNumber,
											pdfImageSignedUrl: a.pdfImageSignedUrl,
											rotationAngle: a.rotationAngle,
											signedUrl: a.signedUrl,
											text: a.text,
											uid: a.uid,
											isDeleted: a.isDeleted,
											isMove: a.isMove,
											isCopy: a.isCopy,
											movedFrom: a.movedFrom,
											wordCoordinates: a.wordCoordinates,
											wordCoordinateMatch: a.wordCoordinateMatch,
											version: a.version,
											versionNumber: a.versionNumber,
											pdfImageKey: a.pdfImageKey,
											pdfKey: a.pdfKey,
											comment: a.comment || '',
											adjustedCoordinates: a.adjustedCoordinates,
											adjustedCoordinateSpace: a.adjustedCoordinateSpace,
											adjustedPageWidth: a.adjustedPageWidth,
											adjustedPageHeight: a.adjustedPageHeight,
											adjustedRotationAngle: a.adjustedRotationAngle,
										};
										hash[a.text].details.push(x);
									};
								})(Object.create(null)),
							);

							clone.priorSearchResults[i].groups[g].finalResult[j].files = result;

							for (
								let a = 0;
								a < clone.priorSearchResults[i].groups[g].finalResult[j].files.length;
								a += 1
							) {
								for (
									let b = 0;
									b < clone.priorSearchResults[i].groups[g].finalResult[j].files[a].details.length;
									b += 1
								) {
									if (
										clone.priorSearchResults[i].groups[g].finalResult[j].files[a].details[b]
											.isDeleted === true
									) {
										clone.priorSearchResults[i].groups[g].finalResult[j].files[a].isDeleted = true;
										break;
									}
								}
							}
						}
					}
				}

			if (clone.diffResults) {
				for (let i = 0; i < clone.diffResults.length; i += 1) {
					for (let g = 0; g < clone.diffResults[i].groups.length; g += 1) {
						for (let j = 0; j < clone.diffResults[i].groups[g].finalResult.length; j += 1) {
							const result: any = [];
							let counter = 0;
							clone.diffResults[i].groups[g].finalResult[j].files.forEach(
								(function (hash) {
									return function (a: any) {
										if (!hash[a.text]) {
											hash[a.text] = {
												text: a.text,
												pdfImageSignedUrl: a.pdfImageSignedUrl,
												...pickProjectAreaResultMetadata(a),
												details: [],
												sid: counter,
											};
											counter += 1;
											result.push(hash[a.text]);
										}
										const x: any = {
											...pickProjectAreaResultMetadata(a),
											coordinates: a.coordinates,
											documentType: a.documentType,
											fileName: a.fileName,
											pageNumber: a.pageNumber,
											pdfImageSignedUrl: a.pdfImageSignedUrl,
											rotationAngle: a.rotationAngle,
											signedUrl: a.signedUrl,
											text: a.text,
											uid: a.uid,
											isDeleted: a.isDeleted,
											isMove: a.isMove,
											isCopy: a.isCopy,
											movedFrom: a.movedFrom,
											wordCoordinates: a.wordCoordinates,
											wordCoordinateMatch: a.wordCoordinateMatch,
											version: a.version,
											versionNumber: a.versionNumber,
											pdfImageKey: a.pdfImageKey,
											pdfKey: a.pdfKey,
											comment: a.comment || a.note || '',
											adjustedCoordinates: a.adjustedCoordinates,
											adjustedCoordinateSpace: a.adjustedCoordinateSpace,
											adjustedPageWidth: a.adjustedPageWidth,
											adjustedPageHeight: a.adjustedPageHeight,
											adjustedRotationAngle: a.adjustedRotationAngle,
											note: a.note,
										};
										hash[a.text].details.push(x);
									};
								})(Object.create(null)),
							);

							clone.diffResults[i].groups[g].finalResult[j].files = result;

							for (
								let a = 0;
								a < clone.diffResults[i].groups[g].finalResult[j].files.length;
								a += 1
							) {
								for (
									let b = 0;
									b < clone.diffResults[i].groups[g].finalResult[j].files[a].details.length;
									b += 1
								) {
									if (
										clone.diffResults[i].groups[g].finalResult[j].files[a].details[b].isDeleted ===
										true
									) {
										clone.diffResults[i].groups[g].finalResult[j].files[a].isDeleted = true;
										break;
									}
								}
							}
						}
					}
				}
			}

			//  arr.sort((a: any, b: any) => a.documentType.localeCompare(b.documentType));

			arr.sort((a: any, b: any) => {
				// Extract timestamp and page numbers from file names
				const timestampA = parseInt(a.fileName.split('_')[1]);
				const pageA = parseInt(a.fileName.split('_')[2].split('.')[0]);
				const timestampB = parseInt(b.fileName.split('_')[1]);
				const pageB = parseInt(b.fileName.split('_')[2].split('.')[0]);
				// Compare timestamps
				if (timestampA !== timestampB) {
					return timestampA - timestampB;
				} // If timestamps are equal, compare page numbers
				return pageA - pageB;
			});
			dispatch(GetTradeResultCopyAction(clone));
			dispatch(GetInteractiveResultAction(arr));
		} catch (error) {
			// console.log(error);
			if (error.data) {
				dispatch(toastFunction('Error', error.data.message ? error.data.message : error.data, ''));
				if (error.data.message === 'Exceeded subscription limit') {
					setTimeout(function () {
						window.location.href = `/profile`;
					}, 3000);
				} else {
					setTimeout(function () {
						window.location.href = `/project/${projectId}`;
					}, 3000);
				}
			} else {
				dispatch(toastFunction('Success', 'Search cancelled', ''));
			}

			// console.log(error);

			// dispatch(toastFunction('Error', error.data.message ? error.data.message : error.data, ''));
			// if (error.data.message === 'Exceeded subscription limit') {
			// 	setTimeout(function () {
			// 		window.location.href = `/profile`;
			// 	}, 3000);
			// } else {
			// 	setTimeout(function () {
			// 		window.location.href = `/project/${projectId}`;
			// 	}, 3000);
			// }
		}
	};
}
export const getTrades = (params?: any): AppThunk => {
	let url = `trade?type=search`;
	if (params && params.includeDeleted) {
		url += '&includeDeleted=true';
	}
	const getConfig = { url: url };
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			data.data.rows.sort((a: any, b: any) =>
				a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' }),
			);
			dispatch(GetTradeListAction(data.data));
		} catch (error) {
			// dispatch(GetRecentDocumentListAction([]));
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};

// export const getTradesMoveCopy = (): AppThunk => {
// 	const getConfig = { url: `trade?type=search` };
// 	return async (dispatch) => {
// 		try {
// 			const { data = {} } = await GET(getConfig);
// 			dispatch(GetTradeListMoveCopyction(data.data));
// 		} catch (error) {
// 			if (error && error.data && error.data.message) {
// 				dispatch(toastFunction('Error', error.data.message, 'Failed to list trades'));
// 			} else {
// 				dispatch(toastFunction('Error', 'Something went wrong', ''));
// 			}
// 		}
// 	};
// };

export const getDocumentTypes = (): AppThunk => {
	const getConfig = { url: `documentTypes` };
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			dispatch({ type: ActionConstant.GET_DOC_TYPE, docList: data.data.rows });
		} catch (error) {
			// dispatch(GetRecentDocumentListAction([]));
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};
// send data related to upload
export interface ProjectDocumentUploadResult {
	id?: number;
	data?: { id?: number };
	documentId?: number;
	message?: string;
}

export function upload(
	datas: any = {},
	types: any = [],
	projId: number,
	docname: any,
): AppThunk<Promise<ProjectDocumentUploadResult>> {
	const nameConvertion = datas.name.replace(/ /g, '-');
	// console.log("upload function is called");
	const postConfig = {
		data: {
			name: nameConvertion,
			type: types,
			drawingDate: datas.drawingDate,
			documentKey: docname,
			fileName: datas.file.name,
			version: datas.version,
			projectArea: datas.projectArea,
			extractionId: datas.extractionId,
			documentConfirmationRunId: datas.documentConfirmationRunId,
			costAuthorizationId: datas.costAuthorizationId,
		},
		url: `project/${projId}/upload`,
	};
	return async (dispatch) => {
		try {
			const { status = 0, data = {} } = await POST(postConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			return data;
		} catch (error) {
			const message =
				error?.data?.message ||
				error?.response?.data?.message ||
				error?.message ||
				'Failed to upload documents to project';
			dispatch(toastFunction('Error', message, ''));
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			throw error;
		}
	};
}

export function findText(
	coordarray: any,
	fileName: any,
	pageNumber: any,
	rotationAngle: any,
	projectId: number,
): AppThunk {
	// to get page value
	const postConfig = {
		url: `text-pdf`,
		data: {
			coordinates: coordarray,
			fileName: fileName,
			pageNumber: pageNumber,
			rotationAngle: rotationAngle,
			projectId,
		},
	};
	return async (dispatch) => {
		try {
			const { data = {} } = await POST(postConfig);
			dispatch(clearPageValueTextList());
			dispatch(GetPageValueTextAction(data));
			if (data.Payload === '""') {
				dispatch(toastFunction('Error', "Couldn't fetch Page number", ''));
			}
		} catch (error) {
			// dispatch(toastFunction('Error', error.data.message, ''));
		}
	};
}

export function cancelUpload(
	data: any = [],
	projectId = 0,
	documentConfirmationRunIds: number[] = [],
): AppThunk {
	const postConfig = {
		data: { Files: data, documentConfirmationRunIds, projectId },
		url: `document/cancel`,
	};
	return async (dispatch) => {
		try {
			const { status = 0 } = await POST(postConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
		}
	};
}

export function deleteListItem(projectID = 0, id = 0): AppThunk {
	const deleteConfig = { url: `document/${projectID}/${id}` };
	return async function (dispatch) {
		try {
			const { status = 0 } = await DELETE(deleteConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			// dispatch(clearData());
			// dispatch(getRecentDocuments(projectID));
			dispatch(toastFunction('Success', 'Document deleted successfully', ''));
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'Document deletion failed', ''));
		}
	};
}

export function removeUser(projectID = 0, id = 0): AppThunk {
	// remove user from project
	const putConfig = { url: `project/${projectID}/users/${id}` };
	return async function (dispatch) {
		try {
			const { status = 0 } = await PUT(putConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			dispatch(clearDataDetails());
			dispatch(getList(projectID));
			dispatch(clearData());
			dispatch(getRecentDocuments(projectID));
			dispatch(clearUsers());
			dispatch(clearAllUsers());
			dispatch(getUsers(projectID));
			dispatch(getAllUsers(projectID, ''));
			dispatch(toastFunction('Success', 'User removed successfully', ''));
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'User removal failed', ''));
		}
	};
}

export function removeHistoryDoc(projectID = 0, id = 0, groupBy = 'division'): AppThunk {
	// remove user from project
	const deleteConfig = { url: `history/${id}` };
	return async function (dispatch) {
		try {
			const { status = 0 } = await DELETE(deleteConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			dispatch(clearSearchHistory());
			// dispatch(getSearchHistory(projectID));
			// eslint-disable-next-line no-use-before-define
			dispatch(getSearchHistoryByDivision(projectID, groupBy));
			dispatch(toastFunction('Success', 'Scope document removed successfully', ''));
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'Scope document removal failed', ''));
		}
	};
}

function projectDetailsReducer(state = initialState, action: ActionType): InitialState {
	switch (action.type) {
		case ActionConstant.GET_LIST: {
			const { data } = action;
			return {
				...state,
				list: data,
				detailsFetching: false,
			};
		}
		case ActionConstant.GET_KEYWORD_DATA: {
			const { data } = action;
			return {
				...state,
				keywordCountData: data,
			};
		}
		case ActionConstant.GET_PROGRESS_DATA: {
			const { data } = action;
			// console.log(data, 'DDDDDDDDDD');
			return {
				...state,
				ProgressCountData: data,
			};
		}
		case ActionConstant.GET_KEYWORD_ID: {
			const { data } = action;
			return {
				...state,
				keywordId: data,
			};
		}
		case ActionConstant.GET_STATUS: {
			return {
				...state,
				statusCode: action.status,
			};
		}
		case ActionConstant.CLEAR_DATA_DETAILS: {
			return {
				...state,
				list: {
					id: 0,
					name: '',
					primaryContact: '',
					phone: '',
					email: '',
					startDate: '',
					location: '',
					structureType: '',
					skinTypes: [],
					showCheckDrawings: true,
					specStoreStatus: '',
				},
				detailsFetching: true,
			};
		}
		case ActionConstant.GET_RECENTDOCUMENTS: {
			// console.log("The recentdocuments variable is being updated with the data");
			const { count = 0, rows = [] } = action.data;
			state.recentdocuments = [];
			return {
				...state,
				recentdocuments: [...state.recentdocuments, ...rows],
				documentcount: count,
				fetching: false,
			};
		}

		case ActionConstant.GET_RECENTSPECIFICATION: {
			const { count = 0, rows = [] } = action.data;
			state.recentSpecifications = [];
			return {
				...state,
				recentSpecifications: [...state.recentSpecifications, ...rows],
				specCount: count,
				fetching: false,
			};
		}

		case ActionConstant.SET_SCOPE_DOCUMENT_CHECKLIST_ROLLUPS: {
			return {
				...state,
				scopeDocumentChecklistProjectRollups: {
					projectId: action.projectId,
					rollups: action.rollups || { byHistoryId: {}, byTradeId: {} },
				},
			};
		}
		case ActionConstant.GET_SEARCHHISTORY: {
			const { searchHistory = [] } = action.data;
			const requestKey = action.requestKey || '';
			if (requestKey) {
				if (
					action.requestId !== undefined &&
					state.searchhistoryRequestIds[requestKey] !== action.requestId
				) {
					return state;
				}
				const cachedHistory = state.searchhistoryByRequestKey[requestKey] || [];
				const nextHistory = action.rollupsOnly
					? mergeSearchHistoryDocumentRollups(cachedHistory, searchHistory)
					: action.silent
					? mergeSearchHistoryRefreshRollups(cachedHistory, searchHistory)
					: [...searchHistory];
				state.searchhistoryByRequestKey = {
					...state.searchhistoryByRequestKey,
					[requestKey]: nextHistory,
				};
				if (state.searchhistoryRequestKey !== requestKey) {
					return { ...state };
				}
			}
			if (action.rollupsOnly) {
				return {
					...state,
					searchhistory: mergeSearchHistoryDocumentRollups(state.searchhistory, searchHistory),
					searchhistoryFetching: false,
				};
			}

			if (action.silent) {
				return {
					...state,
					searchhistory: mergeSearchHistoryRefreshRollups(state.searchhistory, searchHistory),
					searchhistoryFetching: false,
				};
			}

			state.searchhistory = [];
			return {
				...state,
				searchhistory: [...state.searchhistory, ...searchHistory],
				searchhistoryFetching: false,
			};
		}
		case ActionConstant.GET_SEARCHHISTORYDATA: {
			const searchHistoryData: any = action.data;
			state.searchhistorydata = [];
			return {
				...state,
				searchhistorydata: searchHistoryData,
				searchhistoryFetching: false,
			};
		}
		case ActionConstant.GET_AUTOANALYSISLISTDATA: {
			const autoAnalysisListData: any = action.data;
			const nextAutoAnalysisListData = Array.isArray(autoAnalysisListData.autoAnalysisListData)
				? autoAnalysisListData.autoAnalysisListData
				: [];
			const requestKey = action.requestKey || '';
			if (requestKey) {
				if (
					action.requestId !== undefined &&
					state.autoAnalysisListRequestIds[requestKey] !== action.requestId
				) {
					return state;
				}
				state.autoAnalysisListByRequestKey = {
					...state.autoAnalysisListByRequestKey,
					[requestKey]: nextAutoAnalysisListData,
				};
				if (state.autoAnalysisListRequestKey !== requestKey) {
					return { ...state };
				}
			}

			state.autoAnalysisListData = [];
			return {
				...state,
				autoAnalysisListData: autoAnalysisListData.autoAnalysisListData,
				autoAnalysisListFetching: false,
			};
		}
		case ActionConstant.SET_SEARCHHISTORY_FETCHING_COMPLETE: {
			const requestKey = action.requestKey || '';
			if (
				requestKey &&
				(state.searchhistoryRequestKey !== requestKey ||
					(action.requestId !== undefined &&
						state.searchhistoryRequestIds[requestKey] !== action.requestId))
			) {
				return state;
			}

			return {
				...state,
				searchhistoryFetching: false,
			};
		}
		case ActionConstant.SET_AUTOANALYSISLIST_FETCHING_COMPLETE: {
			const requestKey = action.requestKey || '';
			if (
				requestKey &&
				(state.autoAnalysisListRequestKey !== requestKey ||
					(action.requestId !== undefined &&
						state.autoAnalysisListRequestIds[requestKey] !== action.requestId))
			) {
				return state;
			}

			return {
				...state,
				autoAnalysisListFetching: false,
			};
		}

		case ActionConstant.GET_DOCUMENTHISTORY: {
			const { result = [] } = action.data;
			state.documenthistory = [];
			return {
				...state,
				documenthistory: [...state.documenthistory, ...result],
				documenthistoryFetching: false,
			};
		}
		case ActionConstant.GET_USERS: {
			const { count = 0, rows = [] } = action.data;
			state.users = [];
			return {
				...state,
				users: [...state.users, ...rows],
				usercount: count,
				userFetching: false,
			};
		}
		case ActionConstant.GET_ALL_USERS: {
			const { count = 0, rows = [] } = action.data;
			state.allusers = [];
			return {
				...state,
				allusers: [...state.allusers, ...rows],
				allusercount: count,
				alluserFetching: false,
			};
		}
		case ActionConstant.GET_TRADE: {
			const { count = 0, rows = [] } = action.data;
			return {
				...state,
				tradelist: [...state.tradelist, ...rows],
				tradecount: count,
				tradeFetching: false,
			};
		}
		case ActionConstant.GET_DIFF_RESULT: {
			const { diffResults = [], diffResultsCopy = [] } = action;
			return {
				...state,
				diffresultcopy: [...diffResultsCopy],
				diffresult: [...diffResults],
			};
		}
		// case ActionConstant.GET_TRADE_MOVE_COPY: {
		// 	const { count = 0, rows = [] } = action.data;
		// 	return {
		// 		...state,
		// 		tradelist: [...state.tradelist, ...rows],
		// 		tradecount: count,
		// 		tradeFetching: false,
		// 	};
		// }
		case ActionConstant.GET_PAGE_VALUE_LIST: {
			const { data } = action;
			return {
				...state,
				pagevaluelist: data,
				pageValueFetching: false,
			};
		}
		case ActionConstant.GET_PAGE_VALUE_TEXT_LIST: {
			const { data } = action;
			return {
				...state,
				pagevaluetextlist: data,
			};
		}

		case ActionConstant.GET_TRADE_RESULT: {
			const {
				searchResults = [],
				priorSearchResults = [],
				diffResults = [],
				bidPackageColor = ' ',
				scopeChecklistPatches = [],
			} = action.data;
			return {
				...state,
				traderesult: [...searchResults],
				revisionScopeChecklistPatches: [...scopeChecklistPatches],
				priortraderesult: [...priorSearchResults],
				diffresult: [...diffResults],
				traderesultFetching: false,
				bidPackageColor: bidPackageColor,
			};
		}
		case ActionConstant.GET_TRADE_RESULT_MULTI_PACKAGE: {
			const { multiPackageSearchResults = [] } = action.data;
			// console.log([...multiPackageSearchResults], 'FFFFFF');
			return {
				...state,
				multitraderesult: [...multiPackageSearchResults],
			};
		}
		case ActionConstant.GET_INTERACTIVE_RESULT: {
			const data: any = action.data;

			state.interactiveresult = [];
			return {
				...state,
				interactiveresult: data,
			};
		}
		case ActionConstant.GET_MULTI_INTERACTIVE_RESULT: {
			const data: any = action.data;
			state.multiinteractiveresult = [];
			return {
				...state,
				multiinteractiveresult: data,
			};
		}
		case ActionConstant.GET_TRADE_RESULTDATA: {
			const searchResults: any = action.data;
			state.traderesultdata = [];

			return {
				...state,
				traderesultdata: searchResults.data.searchResults,
			};
		}

		case ActionConstant.GET_TRADE_RESULT_COPY: {
			const {
				searchResults = [],
				priorSearchResults = [],
				diffResults = [],
				status = false,
				isActiveProject = true,
			} = action.data;
			return {
				...state,
				traderesultcopy: [...searchResults],
				priortraderesultcopy: [...priorSearchResults],
				diffresultcopy: [...diffResults],
				traderesultFetchingcopy: false,
				tradeResultStatus: status,
				isActiveProject,
			};
		}

		case ActionConstant.GET_MULTI_TRADE_RESULT_COPY: {
			const {
				multiPackageSearchResults = [],
				status = false,
				isActiveProject = true,
			} = action.data;

			return {
				...state,
				multitraderesultcopy: [...multiPackageSearchResults],
				traderesultFetchingcopy: false,
				tradeResultStatus: status,
				isActiveProject,
			};
		}

		case ActionConstant.GET_GENERATE_RESULT_DOCUMENT: {
			const { data } = action;
			return {
				...state,
				generatetraderesult: data,
				generatetraderesultFetching: false,
			};
		}

		case ActionConstant.GET_DOC_TYPE: {
			const { docList } = action;
			return {
				...state,
				docList,
			};
		}
		case ActionConstant.CLEAR_DATA: {
			return {
				...state,
				recentdocuments: [],
				recentSpecifications: [],
				specCount: 0,
				fetching: true,
			};
		}
		case ActionConstant.CLEAR_SEARCHHISTORY: {
			const requestKey = action.requestKey || '';
			if (requestKey) {
				if (action.silent) {
					const hasCachedHistory = Object.prototype.hasOwnProperty.call(
						state.searchhistoryByRequestKey,
						requestKey,
					);
					const sameRequestKey = state.searchhistoryRequestKey === requestKey;
					return {
						...state,
						searchhistory: sameRequestKey
							? state.searchhistory
							: state.searchhistoryByRequestKey[requestKey] || [],
						searchhistoryFetching: sameRequestKey ? state.searchhistoryFetching : !hasCachedHistory,
						searchhistoryRequestIds: {
							...state.searchhistoryRequestIds,
							[requestKey]: action.requestId || 0,
						},
						searchhistoryRequestKey: requestKey,
					};
				}
				return {
					...state,
					searchhistory: state.searchhistoryByRequestKey[requestKey] || [],
					searchhistoryFetching: true,
					searchhistoryRequestIds: {
						...state.searchhistoryRequestIds,
						[requestKey]: action.requestId || 0,
					},
					searchhistoryRequestKey: requestKey,
				};
			}
			return {
				...state,
				searchhistory: [],
				searchhistoryRequestKey: null,
				searchhistoryFetching: true,
			};
		}
		case ActionConstant.CLEAR_AUTOANALYSISLISTDATA: {
			const requestKey = action.requestKey || '';
			if (requestKey) {
				return {
					...state,
					autoAnalysisListData: state.autoAnalysisListByRequestKey[requestKey] || [],
					autoAnalysisListFetching: true,
					autoAnalysisListRequestIds: {
						...state.autoAnalysisListRequestIds,
						[requestKey]: action.requestId || 0,
					},
					autoAnalysisListRequestKey: requestKey,
				};
			}
			return {
				...state,
				autoAnalysisListData: [],
				autoAnalysisListRequestKey: null,
				autoAnalysisListFetching: true,
			};
		}

		case ActionConstant.CLEAR_DOCUMENTHISTORY: {
			return {
				...state,
				documenthistory: [],
				documenthistoryFetching: true,
			};
		}
		case ActionConstant.CLEAR_USERS: {
			return {
				...state,
				users: [],
				usercount: 0,
				userFetching: true,
			};
		}
		case ActionConstant.CLEAR_ALL_USERS: {
			return {
				...state,
				allusers: [],
				allusercount: 0,
				alluserFetching: true,
			};
		}
		case ActionConstant.CLEAR_STATUS: {
			return {
				...state,
				statusCode: 0,
			};
		}
		case ActionConstant.CLEAR_TRADE: {
			return {
				...state,
				tradelist: [],
				tradecount: 0,
				tradeFetching: true,
			};
		}
		case ActionConstant.CLEAR_PAGE_VALUE_LIST: {
			return {
				...state,
				pagevaluelist: {
					coordinates: [],
					name: '',
					pageNumbers: [],
					rotationAngle: [],
				},
				pageValueFetching: true,
			};
		}
		case ActionConstant.CLEAR_PAGE_VALUE_TEXT_LIST: {
			return {
				...state,
				pagevaluetextlist: {
					Payload: '',
				},
			};
		}
		case ActionConstant.CLEAR_TRADE_RESULT: {
			return {
				...state,
				traderesult: [],
				revisionScopeChecklistPatches: [],
				traderesultFetching: true,
			};
		}
		case ActionConstant.CLEAR_PRIOR_RESULT: {
			return {
				...state,
				priortraderesult: [],
			};
		}
		case ActionConstant.CLEAR_MULTI_PACKAGE_TRADE_RESULT: {
			return {
				...state,
				multitraderesult: [],
				traderesultFetching: true,
			};
		}
		case ActionConstant.CLEAR_TRADE_RESULT_COPY: {
			return {
				...state,
				traderesultcopy: [],
				priortraderesultcopy: [],
				diffresultcopy: [],
				traderesultFetchingcopy: true,
				tradeResultStatus: false,
			};
		}
		case ActionConstant.CLEAR_MULTI_TRADE_RESULT_COPY: {
			return {
				...state,
				multitraderesultcopy: [],
				traderesultFetchingcopy: true,
				tradeResultStatus: false,
			};
		}
		case ActionConstant.CLEAR_MULTI_INTERACTIVE_TRADE_RESULT: {
			return {
				...state,
				multiinteractiveresult: [],
			};
		}
		case ActionConstant.CLEAR_SCAN_CURRENT_DRAWINGS: {
			return {
				...state,
				scanCurrentDrawingsResult: [],
				scanCurrentDrawingsFetching: true,
			};
		}
		case ActionConstant.CLEAR_GENERATE_RESULT_DOCUMENT: {
			return {
				...state,
				generatetraderesult: { s3PdfUrl: '', s3ExcelUrl: '' },
				generatetraderesultFetching: true,
			};
		}
		case ActionConstant.GET_SCOPE_DOCS_BY_GROUP: {
			const { data } = action;
			return {
				...state,
				scopeDocumentsArrayByTrade: data,
			};
		}
		case ActionConstant.CLEAR_SCOPE_DOCS_BY_GROUP: {
			return {
				...state,
				scopeDocumentsArrayByTrade: { searchHistory: { title: '', scopeDocuments: [] } },
			};
		}

		case ActionConstant.GET_COORDINATION_DOCS: {
			const { data } = action;
			return {
				...state,
				coordinationDocuments: data.data,
				coordinationDocumentsFetching: false,
			};
		}

		case ActionConstant.CLEAR_COORDINATION_DOCS: {
			return {
				...state,
				scopeDocumentsArrayByTrade: { searchHistory: { title: '', scopeDocuments: [] } },
				coordinationDocuments: { count: 0, rows: [] },
				coordinationDocumentsFetching: true,
			};
		}

		case ActionConstant.GET_ALREADY_SEARCHED_TRADES: {
			const { data } = action;
			return {
				...state,
				alreadySearchedTradesList: data,
				alreadySearchedTradesListFetching: false,
			};
		}

		case ActionConstant.CLEAR_ALREADY_SEARCHED_TRADES: {
			return {
				...state,
				alreadySearchedTradesList: [],
				alreadySearchedTradesListFetching: true,
			};
		}

		case ActionConstant.GET_ALL_PAGES: {
			const { data } = action;
			return {
				...state,
				allPagesList: data.data,
				allPagesFetching: false,
			};
		}

		case ActionConstant.CLEAR_ALL_PAGES: {
			return {
				...state,
				allPagesList: [],
				allPagesFetching: true,
			};
		}

		case ActionConstant.GENERATE_COORDINATION_DOCS: {
			const { data } = action;
			return {
				...state,
				coordinationMarkup: data,
				coordinationMarkupGenerating: false,
			};
		}

		case ActionConstant.CLEAR_GENERATE_COORDINATION_DOCS: {
			return {
				...state,
				coordinationMarkup: {
					coordinationMarkupUrl: '',
					status: '',
				},
				coordinationMarkupGenerating: true,
			};
		}

		case ActionConstant.GET_CURRENT_DRAWINGS: {
			const { data } = action;
			return {
				...state,
				currentDrawings: data,
				currentDrawingsFetching: false,
			};
		}

		case ActionConstant.CLEAR_CURRENT_DRAWINGS_DATA: {
			return {
				...state,
				currentDrawings: [],
				currentDrawingsFetching: true,
			};
		}

		case ActionConstant.GET_CURRENT_SPECIFICATIONS: {
			const { data } = action;
			return {
				...state,
				currentSpecifications: data,
				currentSpecificationsFetching: false,
			};
		}

		case ActionConstant.GET_SPECIFICATION_DETAILS: {
			const { data } = action;

			return {
				...state,
				specificationDetails: [...(state.specificationDetails || []), data],
				specificationDetailsFetching: false,
			};
		}

		case ActionConstant.GET_SPEC_SUMMARY: {
			const { data } = action;
			const existingIndex = state.specSummary.findIndex(
				(item: any) =>
					item.divisionNumber === data.divisionNumber &&
					item.grouping === data.grouping &&
					item.keywordHeading === data.keywordHeading,
			);
			const updatedSpecSummary =
				existingIndex !== -1
					? [
							...state.specSummary.slice(0, existingIndex),
							{ ...state.specSummary[existingIndex], ...data },
							...state.specSummary.slice(existingIndex + 1),
					  ]
					: [...state.specSummary, data];
			return {
				...state,
				specSummary: updatedSpecSummary,
			};
		}

		case ActionConstant.CLEAR_CURRENT_SPECIFICATIONS_DATA: {
			return {
				...state,
				currentSpecifications: [],
				currentSpecificationsFetching: true,
			};
		}

		case ActionConstant.CLEAR__SPECIFICATION_DETAILS_DATA: {
			return {
				...state,
				specificationDetails: [],
				specificationDetailsFetching: true,
			};
		}

		case ActionConstant.CONFIRM_SPECIFICATION: {
			return {
				...state,
			};
		}

		case ActionConstant.GET_SCAN_CURRENT_DRAWINGS: {
			const { data } = action;
			return {
				...state,
				scanCurrentDrawingsResult: data,
				scanCurrentDrawingsFetching: false,
			};
		}

		case ActionConstant.CLEAR_CURRENT_DRAWINGS: {
			return {
				...state,
				scanCurrentDrawingsResult: [],
				scanCurrentDrawingsFetching: true,
			};
		}

		case ActionConstant.GET_CHECK_NEW_DRAWINGS: {
			const { data } = action;
			return {
				...state,
				checkNewDrawingsResult: data,
				checkNewDrawingsResultFetching: false,
			};
		}

		case ActionConstant.CLEAR_CHECK_NEW_DRAWINGS: {
			return {
				...state,
				checkNewDrawingsResult: [],
				checkNewDrawingsResultFetching: true,
			};
		}

		case ActionConstant.SET_MAKE_CURRENT_ACTIVE: {
			return {
				...state,
				isMakeCurrentActive: true,
			};
		}

		case ActionConstant.SET_MAKE_CURRENT_INACTIVE: {
			return {
				...state,
				isMakeCurrentActive: false,
			};
		}

		case ActionConstant.GET_AUTO_ANALYSIS_TRADES_LIST: {
			const { data } = action;
			console.log('aacc ', data);
			return {
				...state,
				autoAnalysisTrades: data.data ? data.data.finalData : [],
				autoAnalysisTradesFetching: false,
				canAutoAnalyze: data.canAutoAnalyze,
				remainingTimeMs: data.remainingTimeMs,
			};
		}

		case ActionConstant.CLEAR_AUTO_ANALYSIS_TRADES_LIST: {
			return {
				...state,
				autoAnalysisTrades: [],
				autoAnalysisTradesFetching: true,
				canAutoAnalyze: true,
				remainingTimeMs: 0,
			};
		}

		case ActionConstant.SET_EXCLUSIVITY_REVIEW_FETCHING: {
			return {
				...state,
				exclusivityReviewFetching: true,
			};
		}

		case ActionConstant.GET_EXCLUSIVITY_REVIEW: {
			const data: any = action.data || { totalHits: 0, pages: [], hits: [] };
			return {
				...state,
				exclusivityReviewData: {
					totalHits: data.totalHits || 0,
					pages: data.pages || [],
					hits: data.hits || [],
				},
				exclusivityReviewFetching: false,
			};
		}

		case ActionConstant.CLEAR_EXCLUSIVITY_REVIEW: {
			return {
				...state,
				exclusivityReviewData: { totalHits: 0, pages: [], hits: [] },
				exclusivityReviewFetching: false,
			};
		}

		case ActionConstant.GET_BID_PACKAGES_LIST: {
			const { data } = action;
			const projectId = Number(action.projectId);
			if (Number.isInteger(projectId) && projectId > 0) {
				const projectKey = String(projectId);
				if (
					action.requestId !== undefined &&
					state.bidPackagesRequestIds[projectKey] !== action.requestId
				) {
					return state;
				}
				const bidPackagesByProjectId = {
					...state.bidPackagesByProjectId,
					[projectKey]: data || [],
				};
				const bidPackagesUpdatedAtByProjectId = action.receivedAt
					? {
							...state.bidPackagesUpdatedAtByProjectId,
							[projectKey]: action.receivedAt,
					  }
					: state.bidPackagesUpdatedAtByProjectId;
				if (state.bidPackagesProjectId !== projectId) {
					return {
						...state,
						bidPackagesByProjectId,
						bidPackagesUpdatedAtByProjectId,
					};
				}
				return {
					...state,
					bidPackages: data || [],
					bidPackagesByProjectId,
					bidPackagesFetching: false,
					bidPackagesUpdatedAtByProjectId,
				};
			}
			return {
				...state,
				bidPackages: data || [],
				bidPackagesFetching: false,
			};
		}

		case ActionConstant.CLEAR_BID_PACKAGES_LIST: {
			const projectId = Number(action.projectId);
			if (Number.isInteger(projectId) && projectId > 0) {
				const projectKey = String(projectId);
				const hasCachedPackages = Object.prototype.hasOwnProperty.call(
					state.bidPackagesByProjectId,
					projectKey,
				);
				return {
					...state,
					bidPackages: state.bidPackagesByProjectId[projectKey] || [],
					bidPackagesFetching: !hasCachedPackages && action.requestId !== undefined,
					bidPackagesProjectId: projectId,
					bidPackagesRequestIds:
						action.requestId === undefined
							? state.bidPackagesRequestIds
							: {
									...state.bidPackagesRequestIds,
									[projectKey]: action.requestId,
							  },
				};
			}
			return {
				...state,
				bidPackages: [],
				bidPackagesFetching: true,
				bidPackagesProjectId: 0,
			};
		}

		case ActionConstant.SET_BID_PACKAGES_FETCHING_COMPLETE: {
			const projectId = Number(action.projectId);
			const projectKey = String(projectId);
			if (
				state.bidPackagesProjectId !== projectId ||
				state.bidPackagesRequestIds[projectKey] !== action.requestId
			) {
				return state;
			}
			return {
				...state,
				bidPackagesFetching: false,
			};
		}

		case ActionConstant.GET_BID_PACKAGE_AUTOSOW_LIST: {
			const { data } = action;
			return {
				...state,
				bidPackageAutoSOWList: data || [],
				bidPackageAutoSOWListFetching: false,
			};
		}

		case ActionConstant.CLEAR_BID_PACKAGES_LIST: {
			return {
				...state,
				bidPackageAutoSOWList: [],
				bidPackageAutoSOWListFetching: true,
			};
		}

		default:
			return state;
	}
}

export function updateScopeDocumentTitle(
	id = 0,
	projectId = 0,
	groupBy: string,
	data: any,
): AppThunk {
	const patchConfig = { url: `history/${id}?projectId=${projectId}`, data };
	return async function (dispatch) {
		try {
			const { status = 0 } = await PATCH(patchConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			// dispatch(getSearchHistory(projectId));
			// eslint-disable-next-line no-use-before-define
			if (data.currentBidPackageId) {
				dispatch(getSearchHistoryByDivision(projectId, groupBy, data.currentBidPackageId));
			} else {
				dispatch(getSearchHistoryByDivision(projectId, groupBy));
			}
			dispatch(toastFunction('Success', 'Title updated successfully', ''));
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'Title update failed', ''));
		}
	};
}

export function regroupAutoAnalysisTradesForPackage(
	groups: any[],
	tradeId: number,
	title: string,
	bidPackageId?: number,
) {
	const nextTitle = String(title || '').trim();
	const numericTradeId = Number(tradeId);
	const numericBidPackageId = Number(bidPackageId);
	if (!nextTitle || !Array.isArray(groups)) return groups;

	let matched = false;
	const regrouped = new Map<string, any>();
	groups.forEach((group: any) => {
		(Array.isArray(group.trades) ? group.trades : []).forEach((trade: any) => {
			const isTarget = Number(trade.id) === numericTradeId;
			matched = matched || isTarget;
			const packageName = isTarget ? nextTitle : group.defaultPackageName;
			const nextTrade = isTarget
				? {
						...trade,
						defaultPackageName: nextTitle,
						...(Number.isInteger(numericBidPackageId) && numericBidPackageId > 0
							? { bidPackageId: numericBidPackageId }
							: {}),
				  }
				: trade;
			const targetGroup = regrouped.get(packageName) || {
				...group,
				defaultPackageName: packageName,
				trades: [],
			};
			targetGroup.trades.push(nextTrade);
			regrouped.set(packageName, targetGroup);
		});
	});

	if (!matched) return groups;
	return Array.from(regrouped.values()).sort((left: any, right: any) =>
		String(left.defaultPackageName).localeCompare(String(right.defaultPackageName), undefined, {
			numeric: true,
			sensitivity: 'base',
		}),
	);
}

export function updateDefaultPackageName(
	id = 0,
	projectId = 0,
	groupBy: string,
	data: any,
): AppThunk {
	const patchConfig = { url: `updatePackageName/${id}?projectId=${projectId}`, data };
	return async function (dispatch, getState) {
		try {
			const { status = 0 } = await PATCH(patchConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			const projectState = getState().projectDetailsStore;
			if (
				Array.isArray(projectState.autoAnalysisTrades) &&
				projectState.autoAnalysisTrades.length
			) {
				dispatch(
					CheckTradesForAutoAnalysisListAction({
						canAutoAnalyze: projectState.canAutoAnalyze,
						data: {
							finalData: regroupAutoAnalysisTradesForPackage(
								projectState.autoAnalysisTrades,
								id,
								data.title,
								data.bidPackageId,
							),
						},
						remainingTimeMs: projectState.remainingTimeMs,
					}),
				);
			}
			dispatch(getSearchHistoryByDivision(projectId, groupBy));
			dispatch(getAutoAnalysisData(projectId));
			dispatch(toastFunction('Success', 'Package name updated successfully', ''));
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'Package name failed', ''));
		}
	};
}

// Used for fetching the saved seacch results for public
export function getSearchDetails(projectId: number, tradeName: string, tradeId?: number): AppThunk {
	const getConfig = {
		url: `projects/${projectId}/historyDetails?tradeId=${tradeId}&tradeName=${tradeName}`,
	};
	return async (dispatch) => {
		try {
			dispatch(clearTradeResult());
			dispatch(clearTradeResultCopy());
			const { data = {} } = await GET(getConfig);

			dispatch(GetTradeResultAction(data));
			// eslint-disable-next-line no-console

			// if (data.status === true) {
			// 	// eslint-disable-next-line no-alert
			// 	alert(
			// 		'Scope documents unable to be generated due to deleted documents.  Please delete the previous trade searches and analyze again',
			// 	);
			// }
			const clone = normalizeKeywordResultsPayload(JSON.parse(JSON.stringify(data)));

			for (let i = 0; i < clone.searchResults.length; i += 1) {
				for (let g = 0; g < clone.searchResults[i].groups.length; g += 1) {
					for (let j = 0; j < clone.searchResults[i].groups[g].finalResult.length; j += 1) {
						const result: any = [];
						let counter = 0;
						clone.searchResults[i].groups[g].finalResult[j].files.forEach(
							(function (hash) {
								return function (a: any) {
									if (!hash[a.text]) {
										hash[a.text] = {
											text: a.text,
											pdfImageSignedUrl: a.pdfImageSignedUrl,
											...pickProjectAreaResultMetadata(a),
											details: [],
											sid: counter,
										};
										counter += 1;
										result.push(hash[a.text]);
									}
									const x: any = {
										...pickProjectAreaResultMetadata(a),
										coordinates: a.coordinates,
										documentType: a.documentType,
										fileName: a.fileName,
										pageNumber: a.pageNumber,
										pdfImageSignedUrl: a.pdfImageSignedUrl,
										rotationAngle: a.rotationAngle,
										signedUrl: a.signedUrl,
										text: a.text,
										uid: a.uid,
										isDeleted: a.isDeleted,
										isMove: a.isMove,
										isCopy: a.isCopy,
										movedFrom: a.movedFrom,
										wordCoordinates: a.wordCoordinates,
										wordCoordinateMatch: a.wordCoordinateMatch,
									};
									hash[a.text].details.push(x);
								};
							})(Object.create(null)),
						);

						clone.searchResults[i].groups[g].finalResult[j].files = result;

						for (
							let a = 0;
							a < clone.searchResults[i].groups[g].finalResult[j].files.length;
							a += 1
						) {
							for (
								let b = 0;
								b < clone.searchResults[i].groups[g].finalResult[j].files[a].details.length;
								b += 1
							) {
								if (
									clone.searchResults[i].groups[g].finalResult[j].files[a].details[b].isDeleted ===
									true
								) {
									clone.searchResults[i].groups[g].finalResult[j].files[a].isDeleted = true;
									break;
								}
							}
						}
					}
				}
			}
			dispatch(GetTradeResultCopyAction(clone));
		} catch (error) {
			// console.log(error);
			dispatch(toastFunction('Error', error.data.message ? error.data.message : error.data, ''));
			// if (error.data.message === 'Exceeded subscription limit') {
			// 	setTimeout(function () {
			// 		window.location.href = `/profile`;
			// 	}, 3000);
			// } else {
			// 	setTimeout(function () {
			// 		window.location.href = `/project/${projectId}`;
			// 	}, 3000);
			// }
		}
	};
}

export function getSearchDetailsData(
	projectId: number,
	tradeName: string,
	tradeId?: number,
): AppThunk {
	const getConfig = {
		url: `projects/${projectId}/historyDetailsData?tradeId=${tradeId}&tradeName=${tradeName}`,
	};
	return async (dispatch) => {
		try {
			dispatch(clearTradeResult());
			dispatch(clearTradeResultCopy());
			const data = await GET(getConfig);

			dispatch(GetTradeResultActionData(data));
			// eslint-disable-next-line no-console
		} catch (error) {
			dispatch(toastFunction('Error', error.data.message ? error.data.message : error.data, ''));
		}
	};
}

export function updatePageType(
	projectId = 0,
	documentId = 0,
	sheets: any,
	sheet: any,
	documentName: string,
): AppThunk {
	const data = {
		// projectId,
		// documentId,
		sheets,
		sheet,
		documentName,
	};
	const patchConfig = { url: `document/${projectId}/${documentId}`, data };
	return async function (dispatch) {
		try {
			const { status = 0 } = await PATCH(patchConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			// dispatch(getSearchHistory(projectId));
			// eslint-disable-next-line no-use-before-define
			// dispatch(getSearchHistoryByDivision(projectId));
			dispatch(toastFunction('Success', 'Type updated successfully', ''));
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'Type update failed', ''));
		}
	};
}

export function deletePage({
	projectId = 0,
	documentId = 0,
	sheets,
	sheet,
	documentName,
	type,
	isMakeCurrentActive,
}: {
	projectId?: number;
	documentId?: number;
	sheets: any;
	sheet: any;
	documentName: string;
	type?: string;
	isMakeCurrentActive?: boolean;
}): AppThunk {
	// export function deletePage(
	// 	projectId = 0,
	// 	documentId = 0,
	// 	sheets: any,
	// 	sheet: any,
	// 	documentName: string,
	// 	type?: string,
	// 	isMakeCurrentActive?: boolean
	// ): AppThunk {
	const data = {
		// projectId,
		// documentId,
		sheets,
		sheet,
		documentName,
		type,
		isMakeCurrentActive,
	};
	console.log('The data to be passed to be deleted: ', data);
	const putConfig = { url: `document/${projectId}/${documentId}/page`, data };
	return async function (dispatch) {
		try {
			const { status = 0 } = await PUT(putConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			// dispatch(getSearchHistory(projectId));
			// eslint-disable-next-line no-use-before-define
			// dispatch(getSearchHistoryByDivision(projectId));
			dispatch(getRecentDocuments(projectId));
			dispatch(toastFunction('Success', 'Sheet deleted successfully', ''));
		} catch (error) {
			// console.log(">>>>>>>>>>=======error occured: ", error);
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'Sheet delete failed', ''));
		}
	};
}

export function currentDrawingUpdate(projectId = 0, documentList: any): AppThunk<Promise<boolean>> {
	const documents = Array.isArray(documentList) ? documentList : [];
	const documentIds = documents
		.map((doc: any) => (typeof doc === 'number' ? doc : doc?.id))
		.filter((id: any) => !!id);
	const documentId = documentIds[0];
	const data = {
		projectId,
		documentIds,
	};
	return async function (dispatch) {
		if (!documentId) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'Current drawing update failed', ''));
			return false;
		}

		const patchConfig = { url: `document/currentDrawingUpdate/${projectId}/${documentId}`, data };
		try {
			const { status = 0 } = await PATCH(patchConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'Current drawing update failed', ''));
			return false;
		}

		// The drawing replacement is committed once PATCH succeeds. A later refresh
		// failure must not report the mutation as failed or allow it to be repeated.
		try {
			await dispatch(getSearchHistoryByDivision(projectId, 'division'));
		} catch (error) {
			// The Make Current flow performs its own retryable history refresh.
		}
		dispatch(toastFunction('Success', 'Current Drawing Updated Successfully', ''));
		return true;
	};
}

export function currentSpecificationUpdate(
	projectId = 0,
	documentList: any,
): AppThunk<Promise<boolean>> {
	const specifications = Array.isArray(documentList) ? documentList : [];
	const specificationIds = specifications
		.map((doc: any) => (typeof doc === 'number' ? doc : doc?.id))
		.filter((id: any) => !!id);
	const specificationId = specificationIds[0];
	const data = {
		projectId,
		specificationIds,
	};
	const patchConfig = {
		url: `document/specification/currentSpecificationUpdate/${projectId}/${specificationId}`,
		data,
	};
	return async function (dispatch) {
		if (!specificationId) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'Current specification update failed', ''));
			return false;
		}

		try {
			const { status = 0 } = await PATCH(patchConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			// dispatch(getSearchHistory(projectId));
			// eslint-disable-next-line no-use-before-define
			dispatch(getSearchHistoryByDivision(projectId, 'division'));
			//dispatch(getSearchHistory)
			dispatch(toastFunction('Success', 'Current specification Updated Successfully', ''));
			return true;
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'Current specification update  failed', ''));
			return false;
		}
	};
}

export function recordChangeLogRevisionAction({
	projectId,
	actionType,
	documentIds = [],
	specificationIds = [],
	previousCurrentItems,
	sheetRefs,
	revisionName,
}: {
	projectId: number;
	actionType: 'SCAN_CURRENT' | 'MAKE_CURRENT';
	documentIds?: number[];
	specificationIds?: number[];
	previousCurrentItems?: PreviousCurrentItems;
	sheetRefs?: any[];
	revisionName?: string;
}): AppThunk<Promise<boolean | any>> {
	const safePreviousCurrentItems = previousCurrentItems
		? buildPreviousCurrentItems(previousCurrentItems)
		: undefined;
	const postConfig = {
		url: `projects/${projectId}/changeLog/revisionActions`,
		data: {
			actionType,
			documentIds,
			specificationIds,
			...(Array.isArray(sheetRefs) ? { sheetRefs } : {}),
			...(revisionName ? { revisionName: String(revisionName).trim() } : {}),
			...(safePreviousCurrentItems ? { previousCurrentItems: safePreviousCurrentItems } : {}),
		},
	};
	return async function (dispatch) {
		try {
			const response = await POST(postConfig);
			const responseData = response?.data?.data || response?.data || {};
			return (
				responseData.session ||
				responseData.drawingRevisionAnalysisSession ||
				responseData.revisionAnalysisSession ||
				(responseData.id !== undefined || responseData.sessionId !== undefined
					? responseData
					: undefined) ||
				true
			);
		} catch (error) {
			console.warn('Failed to record change log revision action', error);
			return false;
		}
	};
}

export function updateAllPageTypeInDoc(
	projectId = 0,
	documentId = 0,
	changedSheets: any,
	sheets: any,
): AppThunk {
	const data = {
		// projectId,
		// documentId,
		sheets,
		changedSheets,
	};
	const patchConfig = { url: `document/${projectId}/${documentId}/allPages`, data };
	return async function (dispatch) {
		try {
			const { status = 0 } = await PATCH(patchConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			// dispatch(getSearchHistory(projectId));
			// eslint-disable-next-line no-use-before-define
			// dispatch(getSearchHistoryByDivision(projectId));
			dispatch(toastFunction('Success', 'Type updated successfully', ''));
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'Type update failed', ''));
		}
	};
}

export const getHistoryByGroup = (projectId: any, name: string): AppThunk => {
	const getConfig = { url: `projects/${projectId}/historyByGroup?name=${name}` };
	return async (dispatch) => {
		try {
			dispatch(ClearScopeDocsByGroup());
			const { data = {} } = await GET(getConfig);
			dispatch(GetScopeDocsByGroup(data));
		} catch (error) {
			// dispatch(GetRecentDocumentListAction([]));
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};

export const getCoordinationDocs = (projectId: any, name: string): AppThunk => {
	const getConfig = { url: `document/${projectId}/coordinationDocs` };
	return async (dispatch) => {
		try {
			dispatch(ClearCoordinationDocs());
			const { data = {} } = await GET(getConfig);
			dispatch(GetCoordinationDocs(data));
		} catch (error) {
			// dispatch(GetRecentDocumentListAction([]));
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};

export const getAlreadySearchedTrades = (
	projectId: any,
	bidPackageId?: any,
	options: {
		silent?: boolean;
		includeTradeCatalog?: boolean;
		exclusivityOnly?: boolean;
	} = {},
): AppThunk => {
	const queryParts = [`projectId=${encodeURIComponent(String(projectId))}`];
	const normalizedBidPackageId = String(bidPackageId ?? '').trim();
	if (
		normalizedBidPackageId &&
		normalizedBidPackageId !== 'null' &&
		normalizedBidPackageId !== 'undefined'
	) {
		queryParts.push(`bidPackageId=${encodeURIComponent(normalizedBidPackageId)}`);
	}
	if (options.includeTradeCatalog) {
		queryParts.push('includeTradeCatalog=true');
	}
	if (options.exclusivityOnly) {
		queryParts.push('exclusivityOnly=true');
	}
	const getConfig = {
		url: `trade/alreadyGenerated?${queryParts.join('&')}`,
	};
	return async (dispatch) => {
		try {
			dispatch(ClearAlreadySearchedTrades());
			const { data = [] } = await GET(getConfig);
			const sortedData = (Array.isArray(data) ? data : []).sort((a: any, b: any) => {
				const left = String(
					a?.defaultTradeName || a?.tradeName || a?.name || a?.title || a?.packageName || '',
				);
				const right = String(
					b?.defaultTradeName || b?.tradeName || b?.name || b?.title || b?.packageName || '',
				);
				return left.localeCompare(right, undefined, { numeric: true, sensitivity: 'base' });
			});
			dispatch(GetAlreadySearchedTrades(sortedData));
		} catch (error) {
			console.log('getAlreadySearchedTrades failed', error);
			dispatch(GetAlreadySearchedTrades([]));
			if (!options.silent) {
				if (error && error.data && error.data.message) {
					dispatch(toastFunction('Error', error.data.message, ''));
				} else {
					dispatch(toastFunction('Error', 'Unable to load the project trade list.', ''));
				}
			}
		}
	};
};

export const getAllPages = (projectId: any): AppThunk => {
	const getConfig = { url: `document/${projectId}/allPages` };
	return async (dispatch) => {
		try {
			dispatch(ClearAllPages());
			const { data = {} } = await GET(getConfig);
			dispatch(GetAllPages(data));
		} catch (error) {
			// dispatch(GetRecentDocumentListAction([]));
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};

export function generateCoordinationMarkup(projectId: number, data: any): AppThunk {
	const postConfig = {
		data: {
			inputData: data,
		},
		url: `document/${projectId}/coordinationDocs`,
	};
	return async (dispatch) => {
		try {
			dispatch(ClearGenerateCoordinationMarkup());
			const { status = 0, data = {} } = await POST(postConfig);
			// dispatch({ type: ActionConstant.GENERATE_COORDINATION_DOCS, status });
			dispatch(GenerateCoordinationMarkup(data));
			dispatch(getCoordinationDocs(projectId, ''));
			return data;
		} catch (error) {
			const message = error?.data?.message || 'Failed to generate the coordination markup';
			dispatch(toastFunction('Error', message, ''));
			dispatch(
				GenerateCoordinationMarkup({
					coordinationMarkupUrl: '',
					message,
					status: 'failed',
				}),
			);
		}
	};
}

export function deleteCoordinationMarkup(projectID = 0, id = 0): AppThunk {
	// remove user from project
	const deleteConfig = { url: `document/${projectID}/coordinationDocs/${id}` };
	return async function (dispatch) {
		try {
			const { status = 0 } = await DELETE(deleteConfig);
			dispatch({ type: ActionConstant.DELETE_COORDINATION_DOC, status });
			// dispatch(clearData());
			dispatch(getCoordinationDocs(projectID, ''));
			dispatch(toastFunction('Success', 'Markup deleted successfully', ''));
		} catch (error) {
			dispatch({ type: ActionConstant.DELETE_COORDINATION_DOC, status: 0 });
			dispatch(toastFunction('Error', 'Markup deletion failed', ''));
		}
	};
}

export function updateCoordinationDocTitle(id = 0, projectId = 0, data: any): AppThunk {
	const patchConfig = { url: `document/${projectId}/coordinationDocs/${id}`, data };
	return async function (dispatch) {
		try {
			const { status = 0 } = await PATCH(patchConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			// eslint-disable-next-line no-use-before-define
			dispatch(getCoordinationDocs(projectId, ''));
			dispatch(toastFunction('Success', 'Markup title updated successfully', ''));
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'Markup title update failed', ''));
		}
	};
}

let currentDrawingsRequestVersion = 0;

export const getCurrentDrawings = (datas: any = {}): AppThunk<Promise<any[] | null>> => {
	// console.log("The getCurrentDrawings function is called.===============");
	const getConfig = {
		url: `document/currentDrawings?sortKey=name&sortOrder=asc&projectId=${datas}`,
	};
	const requestVersion = ++currentDrawingsRequestVersion;
	// console.log("The url is fetched and getConfig data is retrieved");
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			const currentDrawings = Array.isArray(data.data) ? data.data : [];
			if (requestVersion === currentDrawingsRequestVersion) {
				dispatch(GetCurrentDrawingsListAction(currentDrawings));
			}
			return currentDrawings;
		} catch (error) {
			if (requestVersion !== currentDrawingsRequestVersion) return null;
			dispatch(GetCurrentDrawingsListAction([]));
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
			return null;
		}
	};
};

export const getCurrentSpecifications = (datas: any = {}): AppThunk<Promise<any[] | null>> => {
	const getConfig = {
		url: `document/specifications/currentSpecifications?sortKey=name&sortOrder=asc&projectId=${datas}`,
	};
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			const currentSpecifications = Array.isArray(data.data) ? data.data : [];
			dispatch(GetCurrentSpecificationsListAction(currentSpecifications));
			return currentSpecifications;
		} catch (error) {
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
			return null;
		}
	};
};

export const getSpecificationDetails = (projectId: any, documentName: any): AppThunk => {
	const getConfig = {
		url: `document/specifications/details?projectId=${projectId}&documentName=${documentName}`,
	};
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			dispatch(GetSpecificationFDetailsListAction(data));
		} catch (error) {
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};

const GetSpecSummaryAction = (data: any): ActionType => ({
	type: ActionConstant.GET_SPEC_SUMMARY,
	data,
});

export const getSpecSummary = (params: {
	tradeId: number;
	projectId: number;
	divisionNumber: string;
	keywordHeading: string;
	grouping: string;
}): AppThunk<Promise<'in_progress' | 'success' | 'error'>> => {
	const getConfig = {
		url: `document/specSummary`,
		params: {
			tradeId: params.tradeId.toString(),
			projectId: params.projectId.toString(),
			divisionNumber: params.divisionNumber,
			keywordHeading: params.keywordHeading,
			grouping: params.grouping,
		},
	};

	return async (dispatch) => {
		try {
			dispatch(
				GetSpecSummaryAction({
					divisionNumber: params.divisionNumber,
					grouping: params.grouping,
					keywordHeading: params.keywordHeading,
					loading: true,
					inProgress: false,
				}),
			);

			const { data = {} } = await GET(getConfig);

			dispatch(
				GetSpecSummaryAction({
					divisionNumber: params.divisionNumber,
					grouping: params.grouping,
					keywordHeading: params.keywordHeading,
					...data,
					loading: false,
					inProgress: false,
				}),
			);

			return 'success';
		} catch (error) {
			const err = error as any;
			if (err?.status === 409 && err?.data?.message?.includes('processed')) {
				dispatch(
					GetSpecSummaryAction({
						divisionNumber: params.divisionNumber,
						grouping: params.grouping,
						keywordHeading: params.keywordHeading,
						loading: false,
						inProgress: true,
					}),
				);
				dispatch(toastFunction('Success', err.data.message, ''));
				return 'in_progress';
			} else if (err?.data?.message) {
				dispatch(toastFunction('Error', err.data.message, ''));
			} else {
				dispatch(
					GetSpecSummaryAction({
						divisionNumber: params.divisionNumber,
						grouping: params.grouping,
						keywordHeading: params.keywordHeading,
						specSummaryResult: null,
						loading: false,
					}),
				);
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
			return 'error';
		}
	};
};

const ConfirmSpecificationAction = (): ConfirmSpecification => ({
	type: ActionConstant.CONFIRM_SPECIFICATION,
});

export const confirmSpecification = (datas: any = {}, projId: number): AppThunk => {
	// const nameConvertion = datas.name.replaceAll(' ', '-');

	// console.log(nameConvertion,'nameConvertion')

	const postConfig = {
		data: {
			name: datas.specName,
			drawingDate: datas.docDate,
			documentKey: datas.specificationKey,
			fileName: datas.currentFile,
			version: datas.version,
			pages: datas.numPages,
			specArray: datas.specificationDetails,
			fileKey: datas.fileKey,
			projectArea: datas.projectArea,
			localSpecificationIngestionRunId: datas.localSpecificationIngestionRunId,
			documentConfirmationRunId: datas.documentConfirmationRunId,
			costAuthorizationId: datas.costAuthorizationId,
		},
		url: `document/upload/specification/${projId}`,
	};
	return async (dispatch) => {
		try {
			const { status = 0 } = await POST(postConfig);
			dispatch(ConfirmSpecificationAction());
			dispatch({ type: ActionConstant.GET_STATUS, status });
			dispatch(toastFunction('Success', 'Specification confirmed successfully', ''));
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Specification confirmation failed', ''));
			}
			throw error;
		}
	};
};

export const scanCurrentDrawings = (
	projectId: any,
	sheets: any,
	documentIds: number[] = [],
): AppThunk => {
	// console.log(sheets, 'datas');
	// const getConfig = { url: `document/scanCurrentDrawings?sortKey=name&sortOrder=asc&projectId=${datas}` };
	const postConfig = {
		data: {
			projectId,
			sheets,
			documentIds,
		},
		url: `document/scanCurrentDrawings`,
	};
	return async (dispatch) => {
		try {
			const { data = {} } = await POST(postConfig);
			console.log('The backend has fetched the latest sheet data and returned');
			console.log('The latest data are: ');
			console.log(data);
			dispatch(ScanCurrentDrawingsListAction(data));
		} catch (error) {
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
			throw error;
		}
	};
};

export const checkForNewDrawings = (datas: any = {}): AppThunk => {
	const params = new URLSearchParams(datas).toString();
	const getConfig = {
		url: `document/checkForNewDrawings?${params}`,
	};

	return async (dispatch) => {
		try {
			dispatch(ClearCheckForNewDrawingsListAction());
			const { data = {} } = await GET(getConfig);
			dispatch(CheckForNewDrawingsListAction(data.data));
		} catch (error) {
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};

export function newDrawingsSearch(
	projectId: number,
	tradeName: string,
	pagesResult: any,
	tradeId?: any,
	rowId?: any,
	cancelToken?: any,
	searchHistoryId?: any,
	revisionMode?: 'MAKE_CURRENT' | 'SCAN_CURRENT',
	drawingRevisionAnalysisSessionId?: number | string | null,
	suppressRedirect = false,
): AppThunk {
	const postConfig = {
		url: `projects/${projectId}/newDrawingsSearch`,
		cancelToken: cancelToken,
		data: {
			data: {
				projectId,
				tradeId,
				tradeName,
				pagesResult,
				rowId: rowId?.rowId,
				...(searchHistoryId ? { searchHistoryId } : {}),
				...(revisionMode ? { revisionMode } : {}),
				...(drawingRevisionAnalysisSessionId !== undefined &&
				drawingRevisionAnalysisSessionId !== null
					? { drawingRevisionAnalysisSessionId }
					: {}),
			},
		},
	};
	return async (dispatch) => {
		try {
			dispatch(clearTradeResult());
			dispatch(clearTradeResultCopy());
			const { data = {} } = await POST(postConfig);
			dispatch(GetTradeResultAction(data));
			// eslint-disable-next-line no-console
			// if (data.status === true) {
			// 	// eslint-disable-next-line no-alert
			// 	alert(
			// 		'Scope documents unable to be generated due to deleted documents.  Please delete the previous trade searches and analyze again',
			// 	);
			// }

			let arr: any = [];
			data.searchResults.forEach((fr: any) => {
				fr.groups.forEach((g: any) => {
					g.finalResult.forEach((fr: any) => {
						fr.files.forEach((pn: any) => {
							arr.push({
								keyword: fr.keyword,
								...pickProjectAreaResultMetadata(pn),
								coordinates: pn.coordinates,
								wordCoordinates: pn.wordCoordinates,
								wordCoordinateMatch: pn.wordCoordinateMatch,
								rotationAngle: pn.rotationAngle,
								signedUrl: pn.signedUrl,
								pdfImageSignedUrl: pn.pdfImageSignedUrl,
								pageNumber: pn.pageNumber,
								uid: pn.uid,
								isDeleted: pn.isDeleted,
								documentType: pn.documentType,
								fileName: pn.fileName,
								version: pn.version,
								versionNumber: pn.versionNumber,
								comment: pn.comment || '',
								adjustedCoordinates: pn.adjustedCoordinates,
								adjustedCoordinateSpace: pn.adjustedCoordinateSpace,
								adjustedPageWidth: pn.adjustedPageWidth,
								adjustedPageHeight: pn.adjustedPageHeight,
								adjustedRotationAngle: pn.adjustedRotationAngle,
							});
						});
					});
				});
			});

			const clone = normalizeKeywordResultsPayload(JSON.parse(JSON.stringify(data)));

			for (let i = 0; i < clone.searchResults.length; i += 1) {
				for (let g = 0; g < clone.searchResults[i].groups.length; g += 1) {
					for (let j = 0; j < clone.searchResults[i].groups[g].finalResult.length; j += 1) {
						const result: any = [];
						let counter = 0;
						clone.searchResults[i].groups[g].finalResult[j].files.forEach(
							(function (hash) {
								return function (a: any) {
									if (!hash[a.text]) {
										hash[a.text] = {
											text: a.text,
											pdfImageSignedUrl: a.pdfImageSignedUrl,
											...pickProjectAreaResultMetadata(a),
											details: [],
											sid: counter,
										};
										counter += 1;
										result.push(hash[a.text]);
									}
									const x: any = {
										...pickProjectAreaResultMetadata(a),
										coordinates: a.coordinates,
										documentType: a.documentType,
										fileName: a.fileName,
										pageNumber: a.pageNumber,
										pdfImageSignedUrl: a.pdfImageSignedUrl,
										rotationAngle: a.rotationAngle,
										signedUrl: a.signedUrl,
										text: a.text,
										uid: a.uid,
										isDeleted: a.isDeleted,
										isMove: a.isMove,
										isCopy: a.isCopy,
										movedFrom: a.movedFrom,
										wordCoordinates: a.wordCoordinates,
										wordCoordinateMatch: a.wordCoordinateMatch,
										version: a.version,
										versionNumber: a.versionNumber,
										pdfImageKey: a.pdfImageKey,
										pdfKey: a.pdfKey,
										comment: a.comment || a.note || '',
										adjustedCoordinates: a.adjustedCoordinates,
										adjustedCoordinateSpace: a.adjustedCoordinateSpace,
										adjustedPageWidth: a.adjustedPageWidth,
										adjustedPageHeight: a.adjustedPageHeight,
										adjustedRotationAngle: a.adjustedRotationAngle,
										note: a.note,
									};
									hash[a.text].details.push(x);
								};
							})(Object.create(null)),
						);

						clone.searchResults[i].groups[g].finalResult[j].files = result;

						for (
							let a = 0;
							a < clone.searchResults[i].groups[g].finalResult[j].files.length;
							a += 1
						) {
							for (
								let b = 0;
								b < clone.searchResults[i].groups[g].finalResult[j].files[a].details.length;
								b += 1
							) {
								if (
									clone.searchResults[i].groups[g].finalResult[j].files[a].details[b].isDeleted ===
									true
								) {
									clone.searchResults[i].groups[g].finalResult[j].files[a].isDeleted = true;
									break;
								}
							}
						}
					}
				}
			}
			// console.log(arr, 'arr');
			//  arr.sort((a: any, b: any) => a.documentType.localeCompare(b.documentType));

			arr.sort((a: any, b: any) => {
				// Extract timestamp and page numbers from file names
				const timestampA = parseInt(a.fileName.split('_')[1]);
				const pageA = parseInt(a.fileName.split('_')[2].split('.')[0]);
				const timestampB = parseInt(b.fileName.split('_')[1]);
				const pageB = parseInt(b.fileName.split('_')[2].split('.')[0]);
				// Compare timestamps
				if (timestampA !== timestampB) {
					return timestampA - timestampB;
				} // If timestamps are equal, compare page numbers
				return pageA - pageB;
			});
			dispatch(GetTradeResultCopyAction(clone));
			dispatch(GetInteractiveResultAction(arr));
			return true;
		} catch (error) {
			if (suppressRedirect) {
				return false;
			}
			// console.log(error);
			if (error.data) {
				dispatch(toastFunction('Error', error.data.message ? error.data.message : error.data, ''));
				if (error.data.message === 'Exceeded subscription limit') {
					setTimeout(function () {
						window.location.href = `/profile`;
					}, 3000);
				} else {
					setTimeout(function () {
						window.location.href = `/project/${projectId}`;
					}, 3000);
				}
			} else {
				dispatch(toastFunction('Success', 'Search cancelled', ''));
			}
			return false;

			// console.log(error);

			// dispatch(toastFunction('Error', error.data.message ? error.data.message : error.data, ''));
			// if (error.data.message === 'Exceeded subscription limit') {
			// 	setTimeout(function () {
			// 		window.location.href = `/profile`;
			// 	}, 3000);
			// } else {
			// 	setTimeout(function () {
			// 		window.location.href = `/project/${projectId}`;
			// 	}, 3000);
			// }
		}
	};
}

export function reverseTransformation(sourceArray: any) {
	if (!sourceArray || !sourceArray.length) return sourceArray;

	for (let i = 0; i < sourceArray.length; i += 1) {
		for (let g = 0; g < sourceArray[i].groups.length; g += 1) {
			for (let j = 0; j < sourceArray[i].groups[g].finalResult.length; j += 1) {
				const filesArray: any[] = [];

				for (let a = 0; a < sourceArray[i].groups[g].finalResult[j].files.length; a += 1) {
					const file = sourceArray[i].groups[g].finalResult[j].files[a];

					for (let b = 0; b < file.details.length; b += 1) {
						const detail = file.details[b];

						const reconstructedFile = {
							coordinates: detail.coordinates,
							documentType: detail.documentType,
							fileName: detail.fileName,
							pageNumber: detail.pageNumber,
							pdfImageSignedUrl: detail.pdfImageSignedUrl,
							rotationAngle: detail.rotationAngle,
							signedUrl: detail.signedUrl,
							text: detail.text,
							uid: detail.uid,
							isDeleted: detail.isDeleted,
							isMove: detail.isMove,
							isCopy: detail.isCopy,
							movedFrom: detail.movedFrom,
							wordCoordinates: detail.wordCoordinates,
							wordCoordinateMatch: detail.wordCoordinateMatch,
							version: detail.version,
							versionNumber: detail.versionNumber,
							note: detail?.note ? detail.note : '',
							pdfImageKey: detail.pdfImageKey,
							pdfKey: detail.pdfKey,
						};

						filesArray.push(reconstructedFile);
					}
				}

				sourceArray[i].groups[g].finalResult[j].files = filesArray;
			}
		}
	}
	// console.log('diff outt', sourceArray)
	return sourceArray;
}

export function getTradesForAutoAnalysis(datas: any): AppThunk {
	const { projectId } = datas;
	// console.log(projectId, 'projectIdsssssssss');
	const getConfig = {
		url: `trade/tradesForAutoAnalysis`,
		params: { projectId },
	};

	return async (dispatch) => {
		try {
			dispatch(ClearTradesForAutoAnalysisListAction());
			const { data = {} } = await GET(getConfig);
			// console.log(data.data.finalData, 'DDDDDDDDDDD');
			dispatch(CheckTradesForAutoAnalysisListAction(data));
		} catch (error) {
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
}

export function startAutoAnalysis(datas: any): AppThunk<Promise<any>> {
	const {
		projectId,
		trades,
		isNewDrawing,
		pagesResult,
		revisionMode,
		revisionContexts,
		tradeBidPackageMap,
	} = datas;

	const postConfig = {
		data: {
			projectId,
			trades,
			isNewDrawing,
			pagesResult,
			revisionMode,
			revisionContexts,
			costInitiationKey: `auto-analysis-${projectId}-${Date.now()}-${Math.random()
				.toString(36)
				.slice(2)}`,
			...(tradeBidPackageMap ? { tradeBidPackageMap } : {}),
		},
		url: `trade/search/autoAnalysis`,
	};
	return async (dispatch) => {
		try {
			toast('Trades are in line for analysis', {
				autoClose: false,
				hideProgressBar: true,
				closeOnClick: true,
				style: { backgroundColor: '#02A2B9', color: 'white' },
			});
			const response = await POST(postConfig);
			// setTimeout(() => dispatch(getAutoAnalysisData(projectId)), 5000);
			// dispatch(getAutoAnalysisData(projectId));
			// dispatch(getSearchHistoryData(projectId, 'trade'));
			console.log('Starting Auto Analysis');
			toast.dismiss();
			toast('Auto-analysis is in progress', {
				autoClose: 5000,
				hideProgressBar: true,
				closeOnClick: true,
				style: { backgroundColor: '#1BA345', color: 'white' },
			});
			return response?.data ?? response;
		} catch (error) {
			toast.dismiss();
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
			return false;
		}
	};
}

export function getExclusivityReview(
	projectId: number,
	options: { silent?: boolean; summary?: boolean } = {},
): AppThunk<Promise<any>> {
	const getConfig = {
		url: `projects/${projectId}/exclusivityReview${options.summary ? '?summary=true' : ''}`,
	};

	return async (dispatch) => {
		try {
			dispatch(SetExclusivityReviewFetchingAction());
			const { data = {} } = await GET(getConfig);
			dispatch(GetExclusivityReviewAction(data));
			return data;
		} catch (error) {
			dispatch(ClearExclusivityReviewAction());
			if (!options.silent) {
				if (error && error.data && error.data.message) {
					dispatch(toastFunction('Error', error.data.message, ''));
				} else {
					dispatch(
						toastFunction(
							'Error',
							'Unable to load exclusivity review. Make sure the API is running.',
							'',
						),
					);
				}
			}
			throw error;
		}
	};
}

export function saveExclusivityReview(projectId: number, decisions: any[]): AppThunk<Promise<any>> {
	const postConfig = {
		url: `projects/${projectId}/exclusivityReview/save`,
		data: { decisions },
	};

	return async (dispatch) => {
		try {
			const { data = {} } = await POST(postConfig);
			dispatch(toastFunction('Success', 'Exclusivity review progress saved successfully', ''));
			await dispatch(getExclusivityReview(projectId, { silent: true }));
			await dispatch(refreshScopeDocumentChecklistRollups(projectId));
			await dispatch(
				getAlreadySearchedTrades(projectId, undefined, {
					silent: true,
					includeTradeCatalog: true,
				}),
			);
			return data;
		} catch (error) {
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
			throw error;
		}
	};
}

export const getBidPackages = (
	projectId: number,
	options: { force?: boolean } = {},
): AppThunk<Promise<any>> => {
	const normalizedProjectId = Number(projectId);
	return async (dispatch, getState) => {
		if (!Number.isInteger(normalizedProjectId) || normalizedProjectId < 1) return [];

		const projectKey = String(normalizedProjectId);
		const projectState = getState().projectDetailsStore;
		const hasCachedPackages = Object.prototype.hasOwnProperty.call(
			projectState.bidPackagesByProjectId,
			projectKey,
		);
		const cachedPackages = projectState.bidPackagesByProjectId[projectKey] || [];
		const cacheUpdatedAt = Number(projectState.bidPackagesUpdatedAtByProjectId[projectKey] || 0);

		const inFlightRequest = bidPackageRequestsInFlight.get(normalizedProjectId);
		if (inFlightRequest) {
			dispatch(ClearBidPackagesListAction(normalizedProjectId));
			return inFlightRequest;
		}

		if (!options.force) {
			if (hasCachedPackages && Date.now() - cacheUpdatedAt < BID_PACKAGE_CACHE_TTL_MS) {
				dispatch(ClearBidPackagesListAction(normalizedProjectId));
				return cachedPackages;
			}
		}

		const requestId = ++bidPackageRequestSequence;
		dispatch(ClearBidPackagesListAction(normalizedProjectId, requestId));
		let renderedFastResponse = hasCachedPackages;
		const request = (async () => {
			if (!hasCachedPackages) {
				try {
					const { data: summaryData = [] } = await GET({
						url: `project/${normalizedProjectId}/bidPackages?summary=true`,
					});
					const summaryRows = filterProjectBidPackages(summaryData, normalizedProjectId);
					dispatch(GetBidPackagesListAction(summaryRows, normalizedProjectId, requestId));
					renderedFastResponse = true;
				} catch (error) {
					// The full request below remains the fallback when the lightweight path fails.
				}
			}

			try {
				const { data: fullData = [] } = await GET({
					url: `project/${normalizedProjectId}/bidPackages`,
				});
				const fullRows = filterProjectBidPackages(fullData, normalizedProjectId);
				dispatch(GetBidPackagesListAction(fullRows, normalizedProjectId, requestId, Date.now()));
				return fullRows;
			} catch (error) {
				dispatch(SetBidPackagesFetchingCompleteAction(normalizedProjectId, requestId));
				if (!renderedFastResponse) {
					if (error && error.data && error.data.message) {
						dispatch(toastFunction('Error', error.data.message, ''));
					} else {
						dispatch(toastFunction('Error', 'Something went wrong', ''));
					}
				}
				return undefined;
			}
		})();

		bidPackageRequestsInFlight.set(normalizedProjectId, request);
		try {
			return await request;
		} finally {
			if (bidPackageRequestsInFlight.get(normalizedProjectId) === request) {
				bidPackageRequestsInFlight.delete(normalizedProjectId);
			}
		}
	};
};

export const refreshInteractiveReviewChecklistState = (
	projectId: number,
): AppThunk<Promise<any>> => {
	const normalizedProjectId = Number(projectId);
	return async (dispatch) => {
		if (!Number.isInteger(normalizedProjectId) || normalizedProjectId < 1) {
			return { projectId: normalizedProjectId, skipped: true };
		}

		const previousRefresh = interactiveReviewChecklistRefreshesInFlight.get(normalizedProjectId);
		const refresh = (previousRefresh || Promise.resolve())
			.catch(() => undefined)
			.then(async () => {
				const [searchHistory, bidPackages] = await Promise.all([
					dispatch(
						getSearchHistoryByDivision(normalizedProjectId, 'trade', undefined, {
							silent: true,
						}),
					),
					dispatch(getBidPackages(normalizedProjectId, { force: true })),
				]);
				const rollups = await dispatch(refreshScopeDocumentChecklistRollups(normalizedProjectId));
				return {
					projectId: normalizedProjectId,
					searchHistory,
					bidPackages,
					rollups,
					failed:
						searchHistory === undefined ||
						bidPackages === undefined ||
						Boolean(rollups && rollups.failed),
				};
			});

		interactiveReviewChecklistRefreshesInFlight.set(normalizedProjectId, refresh);
		try {
			return await refresh;
		} finally {
			if (interactiveReviewChecklistRefreshesInFlight.get(normalizedProjectId) === refresh) {
				interactiveReviewChecklistRefreshesInFlight.delete(normalizedProjectId);
			}
		}
	};
};

export function createBidPackage(datas: any = {}): AppThunk {
	const { projectId, name, color } = datas;
	const postConfig = {
		data: { projectId, name, color },
		url: `project/${projectId}/bidPackages`,
	};
	return async (dispatch) => {
		try {
			await POST(postConfig);
			dispatch(getBidPackages(projectId, { force: true }));
			dispatch(toastFunction('Success', 'Bid package created successfully', ''));
		} catch (error) {
			dispatch(toastFunction('Error', error.data.message, ''));
		}
	};
}

export function updateBidPackage(datas: any = {}): AppThunk {
	const { id, projectId, name, color } = datas;
	const putConfig = {
		data: { projectId, name, color },
		url: `project/${projectId}/bidPackages/${id}`,
	};
	return async (dispatch) => {
		try {
			await PUT(putConfig);
			dispatch(getBidPackages(projectId, { force: true }));
			dispatch(toastFunction('Success', 'Bid package updated successfully', ''));
		} catch (error) {
			dispatch(toastFunction('Error', error.data.message, ''));
		}
	};
}
export function getBidPackageAutoSOW(projectId: number, id: number): AppThunk {
	return async (dispatch) => {
		const cacheKey = `AUTO_SOW_PROMPT_RESULT_${projectId}_${id}`;

		try {
			//  Check if data already exists in localStorage
			const cachedData = localStorage.getItem(cacheKey);

			if (cachedData) {
				const parsedData = JSON.parse(cachedData);
				if (parsedData && Object.keys(parsedData).length > 0) {
					dispatch(GetBidPackageAutoSOWListAction(parsedData));
					return;
				}
			}
			const getConfig = { url: `project/${projectId}/bidPackages/${id}/autoSOW` };
			dispatch(ClearBidPackageAutoSOWListAction());

			const { data = {} } = await GET(getConfig);
			dispatch(GetBidPackageAutoSOWListAction(data));

			localStorage.setItem(cacheKey, JSON.stringify(data));
		} catch (error) {
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
}

export default projectDetailsReducer;
